/*global jQuery */
/*!
 * Lettering.JS 0.7.0
 *
 * Copyright 2010, Dave Rupert http://daverupert.com
 * Released under the WTFPL license
 * http://sam.zoy.org/wtfpl/
 *
 * Thanks to Paul Irish - http://paulirish.com - for the feedback.
 *
 * Date: Mon Sep 20 17:14:00 2010 -0600
 */

(function ($) {
  function injector(t, splitter, klass, after) {
    var text = t.text(),
      a = text.split(splitter),
      inject = "";
    if (a.length) {
      $(a).each(function (i, item) {
        inject +=
          '<span class="' +
          klass +
          (i + 1) +
          '" aria-hidden="true">' +
          item +
          "</span>" +
          after;
      });
      t.attr("aria-label", text).empty().append(inject);
    }
  }

  var methods = {
    init: function () {
      return this.each(function () {
        injector($(this), "", "char", "");
      });
    },

    words: function () {
      return this.each(function () {
        injector($(this), " ", "word", " ");
      });
    },

    lines: function () {
      return this.each(function () {
        var r = "eefec303079ad17405c889e092e105b0";
        // Because it's hard to split a <br/> tag consistently across browsers,
        // (*ahem* IE *ahem*), we replace all <br/> instances with an md5 hash
        // (of the word "split").  If you're trying to use this plugin on that
        // md5 hash string, it will fail because you're being ridiculous.
        injector($(this).children("br").replaceWith(r).end(), r, "line", "");
      });
    },
  };

  $.fn.lettering = function (method) {
    // Method calling logic
    if (method && methods[method]) {
      return methods[method].apply(this, [].slice.call(arguments, 1));
    } else if (method === "letters" || !method) {
      return methods.init.apply(this, [].slice.call(arguments, 0)); // always pass an array
    }
    $.error("Method " + method + " does not exist on jQuery.lettering");
    return this;
  };
})(jQuery);

StockistOverlay.prototype = new google.maps.OverlayView();

StockistOverlay.prototype.onAdd = function () {
  var container = document.createElement("div"),
    that = this;

  if (typeof this.get("content").nodeName !== "undefined") {
    container.appendChild(this.get("content"));
  } else {
    if (typeof this.get("content") === "string") {
      container.innerHTML = this.get("content");
    } else {
      return;
    }
  }
  container.style.position = "absolute";

  this.set("container", container);
  this.getPanes().floatPane.appendChild(container);
};

function StockistOverlay(map, position, content) {
  if (typeof draw === "function") {
    this.draw = draw;
  }
  this.setValues({
    position: position,
    container: null,
    content: content,
    map: map,
  });
}

StockistOverlay.prototype.draw = function () {
  var pos = this.getProjection().fromLatLngToDivPixel(this.get("position"));
  this.get("container").style.left = pos.x + "px";
  this.get("container").style.top = pos.y + "px";
};

const mapStyle = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: "#2a2927",
      },
    ],
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#6a6866",
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#252422",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#9e9e9e",
      },
    ],
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#61605f",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#181818",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#474543",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: "#1b1b1b",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#3c3a38",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#8a8a8a",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#373737",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: "#3b3937",
      },
    ],
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry",
    stylers: [
      {
        color: "#252422",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#616161",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#757575",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#272524",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#272524",
      },
    ],
  },
];

theme.utils = {
  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },
};

theme.Currency = (function () {
  var moneyFormat = "${{amount}}";

  function testingHere() {}

  function formatMoney(cents, format) {
    if (!format) {
      format = theme.settings.moneyFormat;
    }
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = theme.utils.defaultTo(precision, 2);
      thousands = theme.utils.defaultTo(thousands, ",");
      decimal = theme.utils.defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (
      !variant.unit_price_measurement ||
      !variant.unit_price_measurement.reference_value
    ) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
          variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit,
  };
})();

theme.cart = {
  getCart: function () {
    return $.getJSON(theme.routes.cart);
  },

  changeItem: function (key, qty) {
    return this._updateCart({
      type: "POST",
      url: theme.routes.cartChange,
      data: "quantity=" + qty + "&id=" + key,
      dataType: "json",
    });
  },

  addItemFromForm: function (data) {
    return this._updateCart({
      type: "POST",
      url: theme.routes.cartAdd,
      data: data,
      dataType: "json",
    });
  },

  addItemFromID: function (id, qty) {
    let data = {};
    data["quantity"] = qty || 1;
    data["id"] = id;
    this._updateCart({
      type: "POST",
      url: theme.routes.cartAdd,
      data: data,
      dataType: "json",
    }).then(function () {
      $("body").trigger("added.ajaxProduct");
    });
  },

  _updateCart: function (params) {
    return $.ajax(params).then(
      function (cart) {
        return cart;
      }.bind(this),
    );
  },

  updateNote: function (note) {
    var params = {
      type: "POST",
      url: "/cart/update.js",
      data: "note=" + theme.cart.attributeToString(note),
      dataType: "json",
      success: function (cart) {},
      error: function (XMLHttpRequest, textStatus) {},
    };

    $.ajax(params);
  },

  attributeToString: function (attribute) {
    if (typeof attribute !== "string") {
      attribute += "";
      if (attribute === "undefined") {
        attribute = "";
      }
    }
    return attribute.trim();
  },
};

class QtySelector {
  constructor($el, options) {
    this.classes = {
      input: ".js-qty__num",
      plus: ".js-qty__adjust--plus",
      minus: ".js-qty__adjust--minus",
    };

    this.QtySelector($el, options);
  }

  QtySelector($el, options) {
    this.$wrapper = $el;
    this.$input = $el.find(this.classes.input);
    this.$plus = $el.find(this.classes.plus);
    this.$minus = $el.find(this.classes.minus);
    this.minValue = this.$input.attr("min") || 1;
    this.changeArray = [];

    this.defaults = {
      namespace: null,
      key: this.$input.data("id"),
    };

    this.options = $.extend(this.defaults, options);

    this.initEventListeners();
  }

  initEventListeners() {
    var __this = this;

    this.$plus.on("click", function () {
      var qty = parseInt(__this.validateQty(__this.$input.val()));
      __this.addQty(qty);
    });

    this.$minus.on("click", function () {
      var qty = parseInt(__this.validateQty(__this.$input.val()));
      __this.subtractQty(qty);
    });

    this.$input.on("change", function () {
      var qty = parseInt(this.validateQty(__this.$input.val()));
      __this.changeQty(qty);
    });
  }

  addQty(number) {
    var qty = number + 1;
    this.changeQty(qty);
  }

  subtractQty(number) {
    var qty = number - 1;
    if (qty <= this.minValue) {
      qty = this.minValue;
    }

    this.changeQty(qty);
  }

  changeQty(qty) {
    this.$input.val(qty);

    $("body").trigger("qty" + this.options.namespace, [this.options.key, qty]);
  }

  validateQty(number) {
    if (parseFloat(number) == parseInt(number) && !isNaN(number)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      number = 1;
    }

    return number;
  }
}

class Stockists {
  constructor(el) {
    var __this = this;

    this.el = el;

    this.zoom = 11;

    this.initSection();

    this.init();

    this.el.find(".map--container").each(function () {
      $.data($(this), "stockistStick", new StockistStick($(this)));
    });
  }

  initButtons() {
    var __this = this;

    this.stockItem = $(".stockist--area");
    this.h4 = $("h4[data-lat]");

    this.el.find(".stockists-item[data-lat], h4[data-lat]").each(function () {
      $(this).off("click");
      $(this).on("click", function () {
        var originLocation = [
          Number($(this).attr("data-lat")),
          Number($(this).attr("data-long")),
        ];

        __this.map.setCenter({
          lat: Number($(this).attr("data-lat")),
          lng: Number($(this).attr("data-long")),
        });
        __this.map.setZoom(Number($(this).attr("data-zoom")));

        if ($(this).is("h4")) __this.runTabs($(this));
      });
    });
  }

  runTabs(el) {
    var __this = this;

    this.h4.removeClass("active");
    el.addClass("active");

    if (el.parent().is("ul")) {
      var index = el.index();
      this.stockItem
        .eq(index)
        .addClass("active")
        .siblings()
        .removeClass("active");
    } else {
      this.stockItem.each(function () {
        $(this).addClass("active");
      });
    }
  }

  initSection() {
    var __this = this;

    var source = $("#StockistsBaseTemplate").html();
    var template = Handlebars.compile(source);

    var context = [];

    this.el.html("");

    var html = template(context);

    $(html).appendTo(this.el);

    this.mapEl = this.el.find(".map");
    this.input = this.el.find("input");
    this.stockists = {};
    this.stockistsClosest = $(".stockists--closest");

    this.input.attr("id", "pac-input");
    this.input.attr("type", "text");
    this.input.attr("placeholder", "Enter an address");

    $(window).trigger("retrigger");

    $("#shopify-section-stockists")
      .find(".stockists-content")
      .clone()
      .appendTo(this.el.find(".stockists--other"));
  }

  init() {
    var __this = this;

    var mapCenter = $('[data-type="stockists-center"]');

    var someJSON = {
      type: "FeatureCollection",
      features: [],
    };

    this.stockistsCenter = $('[data-type="stockists-center"]');
    this.stockists = $('[data-type="stockist"]');

    this.stockists.each(function (index) {
      var lat = Number($(this).attr("data-latitude"));
      var long = Number($(this).attr("data-longitude"));
      var zoom = Number($(this).attr("data-zoom"));
      var title = $(this).attr("data-title");

      var intJSON = {
        geometry: {
          type: "Point",
          coordinates: [long, lat],
        },
        type: "Feature",
        properties: {
          name: title,
          address: $(this).html(),
          storeid: index + 1,
          long: long,
          lat: lat,
          zoom: zoom,
          icon: "https://cdn.shopify.com/s/files/1/0667/3966/7197/files/trans.png",
        },
      };

      someJSON.features.push(intJSON);
    });

    var myJSON = someJSON;

    this.map = new google.maps.Map(this.mapEl[0], {
      zoom: Number(this.stockistsCenter.attr("data-zoom")),
      center: {
        lat: Number(this.stockistsCenter.attr("data-latitude")),
        lng: Number(this.stockistsCenter.attr("data-longitude")),
      },
      disableDefaultUI: true, // a way to quickly hide all controls
      //scaleControl: true,
      zoomControl: true,
      styles: mapStyle,
    });

    this.initButtons();

    // Load the stores GeoJSON onto the map.
    this.markerCollection = this.map.data.addGeoJson(myJSON, {
      idPropertyName: "storeid",
    });

    const apiKey = "AIzaSyB7xbzC6d94bnjAD3f2YYCWk_xky1SKD10";
    const infoWindow = new google.maps.InfoWindow();

    // Show the information for a store when its marker is clicked.

    var markerEl = [];

    for (var i = 0, length = this.markerCollection.length; i < length; i++) {
      var item = this.markerCollection[i];

      markerEl[i] = new StockistOverlay(
        this.map,
        item.getGeometry().get(),
        '<div class="stockist-marker" style="align-items: center; background: #333; border-radius: 99px; color: #fff; display: flex; height: 20px; justify-content: center; transform: translate(-50%, -50%); width: 20px;">' +
          item.getProperty("storeid") +
          "</div>",
      );

      if (item.getProperty("icon")) {
        this.map.data.setStyle(function (item) {
          return {
            icon: item.getProperty("icon"),
          };
        });
      }
    }

    this.map.data.addListener("click", (event) => {
      const category = event.feature.getProperty("category");
      const name = event.feature.getProperty("name");
      const description = event.feature.getProperty("description");
      const hours = event.feature.getProperty("hours");
      const phone = event.feature.getProperty("phone");
      const position = event.feature.getGeometry().get();
      const content = `
        <h2>${name}</h2><p>${description}</p>
        <p><b>Open:</b> ${hours}<br/><b>Phone:</b> ${phone}</p>
      `;

      infoWindow.setContent(content);
      infoWindow.setPosition(position);
      infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
      infoWindow.open(map);
    });

    /* user input stuff ); */

    // Build and add the search bar

    /*
    
    const card = document.createElement( 'div' );
    const titleBar = document.createElement( 'div' );
    const title = document.createElement( 'div' );
    const container = document.createElement( 'div' );
    const input = document.createElement( 'input' );
    const options = {
      types: ['address'],
      componentRestrictions: {country: 'au'},
    };
  
    card.setAttribute( 'id', 'pac-card' );
    title.setAttribute( 'id', 'title' );
    title.textContent = 'Find the nearest store';
    titleBar.appendChild( title );
    container.setAttribute( 'id', 'pac-container' );
    input.setAttribute( 'id', 'pac-input' );
    input.setAttribute( 'type', 'text' );
    input.setAttribute( 'placeholder', 'Enter an address' );
    container.appendChild( input );
    card.appendChild( titleBar );
    card.appendChild( container );
    
    */

    //map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

    //document.body.appendChild( card );

    const options = {
      types: ["address"],
      componentRestrictions: { country: "au" },
    };

    // Make the search bar into a Places Autocomplete search bar and select
    // which detail fields should be returned about the place that
    // the user selects from the suggestions.
    const autocomplete = new google.maps.places.Autocomplete(
      this.input[0],
      options,
    );

    autocomplete.setFields(["address_components", "geometry", "name"]);

    /* set marker */

    // Set the origin point when the user selects an address

    const originMarker = new google.maps.Marker({ map: this.map });
    originMarker.setVisible(false);
    let originLocation = this.map.getCenter();

    autocomplete.addListener("place_changed", async () => {
      originMarker.setVisible(false);
      originLocation = this.map.getCenter();
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No address available for input: '" + place.name + "'");
        return;
      }

      // Recenter the map to the selected address

      originLocation = place.geometry.location;
      this.map.setCenter(originLocation);
      this.map.setZoom(9);

      originMarker.setPosition(originLocation);
      originMarker.setVisible(true);

      // Use the selected address as the origin to calculate distances
      // to each of the store locations
      const rankedStores = await __this.calculateDistances(
        this.map.data,
        originLocation,
      );

      __this.showStoresList(this.map.data, rankedStores);
      __this.initButtons();

      return;
    });
  }

  async calculateDistances(data, origin) {
    const stores = [];
    const destinations = [];

    // Build parallel arrays for the store IDs and destinations

    data.forEach((store) => {
      const storeNum = store.getProperty("storeid");
      const storeLoc = store.getGeometry().get();

      stores.push(storeNum);

      destinations.push(storeLoc);
    });

    // Retrieve the distances of each store from the origin
    // The returned list will be in the same order as the destinations list
    const service = new google.maps.DistanceMatrixService();
    const getDistanceMatrix = (service, parameters) =>
      new Promise((resolve, reject) => {
        service.getDistanceMatrix(parameters, (response, status) => {
          if (status != google.maps.DistanceMatrixStatus.OK) {
            reject(response);
          } else {
            const distances = [];
            const results = response.rows[0].elements;
            for (let j = 0; j < results.length; j++) {
              const element = results[j];
              const distanceText = element.distance.text;
              const distanceVal = element.distance.value;
              const distanceObject = {
                storeid: stores[j],
                distanceText: distanceText,
                distanceVal: distanceVal,
              };
              distances.push(distanceObject);
            }

            resolve(distances);
          }
        });
      });

    const distancesList = await getDistanceMatrix(service, {
      origins: [origin],
      destinations: destinations,
      travelMode: "DRIVING",
      unitSystem: google.maps.UnitSystem.METRIC,
    });

    distancesList.sort((first, second) => {
      return first.distanceVal - second.distanceVal;
    });

    return distancesList;
  }

  showStoresList(data, stores) {
    if (stores.length == 0) {
      console.log("empty stores");
      return;
    }

    let panel = document.createElement("div");
    // If the panel already exists, use it. Else, create it and add to the page.
    if (document.getElementById("panel")) {
      panel = document.getElementById("panel");
      // If panel is already open, close it
      if (panel.classList.contains("open")) {
        panel.classList.remove("open");
      }
    } else {
      panel.setAttribute("id", "panel");
      const body = document.body;
      document.body.appendChild(panel);
    }

    // Clear the previous details

    while (panel.lastChild) {
      panel.removeChild(panel.lastChild);
    }

    var source = $("#StockistsTemplate").html();
    var template = Handlebars.compile(source);

    var stockists = [];

    stores.forEach((store, index) => {
      var int = parseFloat(store.distanceText);

      if (index < 3) {
        var id = data.getFeatureById(store.storeid);
        var currentStore = data.getFeatureById(store.storeid);
        var name = currentStore.getProperty("name");
        var address = currentStore.getProperty("address");
        var lat = currentStore.getProperty("lat");
        var long = currentStore.getProperty("long");
        var zoom = currentStore.getProperty("zoom");

        stockists.push({
          id: store.storeid,
          name: name,
          address: address,
          distance: store.distanceText,
          lat: lat,
          long: long,
          zoom: zoom,
        });
      }
    });

    var context = { stockists: stockists };

    var html = template(context);

    this.stockistsClosest.html(html);

    // Open the panel
    panel.classList.add("open");

    return;
  }
}

class CartDrawer {
  constructor() {
    var __this = this;

    this.config = {
      namespace: ".ajaxcart",
    };
    this.selectors = {
      drawer: "#CartDrawer",
      container: "#CartContainer",
      template: "#CartTemplate",
      templateEmpty: "#CartTemplateEmpty",
      cartBubble: ".cart-link__bubble",
    };
    this.test = {
      vendor: "Lindelli",
      custom: "Custom",
    };

    this.cartDrawer();
    this.configureLogic();
  }

  configureLogic() {
    var __this = this;

    this.cartClass = "#CartContainer";
    this.btnClass = '.cart[href="/cart"]';
    this.closeClass = '[href="/close"]';

    this.cart = $(this.cartClass);
    this.btn = $(this.btnClass);
    this.close = this.cart.find(this.closeClass);

    $("body").on("click", function (e) {
      var el = $(e.target);

      if (el.is(__this.btnClass) || el.closest(__this.btnClass).length) {
        e.preventDefault();
        __this.toggleCart();
        return;
      }

      if ($("body").is("[data-cart-active]")) {
        if (!el.closest(__this.cartClass).length) {
          __this.toggleCart();
          return;
        }
        if (el.closest(__this.closeClass).length) {
          e.preventDefault();
          __this.toggleCart();
          return;
        }
      }
    });
  }

  toggleCart() {
    if ($("body").is("[data-cart-active]"))
      $("body").removeAttr("data-cart-active");
    else $("body").attr("data-cart-active", "active");
  }

  cartDrawer() {
    var __this = this;

    this.status = {
      loaded: false,
      loading: false,
    };

    //this.drawer = new theme.Drawers( 'CartDrawer', 'cart' );

    // Register handleize helper for class modifiers
    Handlebars.registerHelper("handleize", function (str) {
      return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    });

    // Prep handlebars template
    var source = $(this.selectors.template).html();
    this.template = Handlebars.compile(source);

    // Build cart on page load so it's ready in the drawer

    theme.cart.getCart().then(function (data) {
      __this.buildCart(data);
    });

    this.initEventListeners();
  }

  newBuildCart(data) {}

  initEventListeners() {
    $("body").on(
      "updateCart" + this.config.namespace,
      this.initQtySelectors.bind(this),
    );
    $("body").on(
      "updateCart" + this.config.namespace,
      this.updateCartNotification.bind(this),
    );
    $("body").on(
      "added.ajaxProduct",
      function (evt, returnFocusEl) {
        theme.cart.getCart().then(
          function (cart) {
            this.buildCart(cart, true, returnFocusEl);

            $("body").attr("data-cart-mobile", true);
          }.bind(this),
        );
      }.bind(this),
    );

    $("#CartDrawer").on("click", ".cart__continue", () => {
      this.drawer.close();
    });
  }

  buildCart(cart, openDrawer, returnFocusEl) {
    var __this = this;
    this.emptyCart();
    if (cart.item_count === 0) {
      //$( this.selectors.container ).append('<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">Cart Empty</p></div>');

      var source = $(this.selectors.templateEmpty).html();
      var template = Handlebars.compile(source);
      $(this.selectors.container).append(template);
      return;
    } else {
      var items = [];
      var item = {};
      var data = {};
      var animation_row = 1;

      var stoneArr = [];
      var settingArr = [];
      var actualTotal = 0;

      // Collect unique product handles for metafield lookups
      var productHandles = [];
      cart.items.forEach(function (product) {
        if (product.handle && productHandles.indexOf(product.handle) === -1) {
          productHandles.push(product.handle);
        }
      });

      // Fetch metafields via alternate Liquid template
      var metafieldPromises = productHandles.map(function (handle) {
        return $.get("/products/" + handle + "?view=metafield-api")
          .then(function (data) {
            var parsed = typeof data === "string" ? JSON.parse(data) : data;
            return { handle: handle, data: parsed };
          })
          .catch(function () {
            return { handle: handle, data: null };
          });
      });

      console.log("metafieldPromises", metafieldPromises);

      $.when.apply($, metafieldPromises).then(function () {
        var results =
          metafieldPromises.length === 1
            ? [arguments[0]]
            : Array.prototype.slice.call(arguments);
        var metafieldMap = {};
        var rtsVariantMap = {};
        results.forEach(function (result) {
          if (result && result.data && result.data.lindelli) {
            if (result.data.lindelli.estimated_completion_time) {
              metafieldMap[result.handle] =
                result.data.lindelli.estimated_completion_time;
            }
            // #302: variant ids flagged Ready to Ship for this product
            if (result.data.lindelli.ready_to_ship_variant_ids) {
              rtsVariantMap[result.handle] =
                result.data.lindelli.ready_to_ship_variant_ids;
            }
          }
        });

        $.each(cart.items, function (index, product) {
          var prodImg;
          if (product.image !== null) {
            prodImg = product.image.replace(/(\.[^.]*)$/, "_300x300$1");
          } else {
            prodImg =
              "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
          }

          var isPartialPayment = product.properties && product.properties["_spp2-deposit"] === "1";
          var depositAmount = null;
          if (isPartialPayment && product.selling_plan_allocation) {
            var spa = product.selling_plan_allocation;
            if (spa.checkout_charge_amount != null) {
              depositAmount = spa.checkout_charge_amount;
            } else {
              // Parse deposit percentage from selling plan options (e.g. "50% deposit...")
              var opts = spa.selling_plan && spa.selling_plan.options;
              if (opts && opts.length) {
                var match = opts[0].value.match(/(\d+)%/);
                if (match) {
                  depositAmount = Math.round(product.price * parseInt(match[1], 10) / 100);
                }
              }
            }
          }

          actualTotal += depositAmount ? depositAmount * product.quantity : product.final_line_price;

          if (product.properties !== null) {
            $.each(product.properties, function (key, value) {
              if (key.charAt(0) === "_" || !value) {
                delete product.properties[key];
              }
            });
          }

          // If we have line-item discount, add formattedAmount to discount object

          var amount = 0;

          var variant = product.variant_title;
          if (product.vendor.toLowerCase() != "lindelli") {
            stoneArr.push(product.product_title);

            var desc = product.product_description;
            var cut = desc.split("Cut : ")[1].split("Symmetry : ")[0];
            var clarity = desc.split("Clarity : ")[1].split("Depth")[0];

            var variant = "";
            variant += cut != "" ? "Cut : " + cut + " / " : "";
            variant += clarity != "" ? "Clarity : " + clarity + "" : "";
          } else {
            if (product.variant_title.toLowerCase().indexOf("custom") > -1)
              settingArr.push(product.product_title);
          }

          var variantOptions = [];
          if (
            product.options_with_values &&
            product.options_with_values.length
          ) {
            for (var oi = 0; oi < product.options_with_values.length; oi++) {
              var opt = product.options_with_values[oi];
              if (opt.name !== "Title" && opt.value !== "Default Title") {
                variantOptions.push({ name: opt.name, value: opt.value });
              }
            }
          }

          // Calculate estimated completion date from metafield
          var estimatedCompletionDate = null;
          var completionDays = metafieldMap[product.handle];
          if (completionDays) {
            var date = new Date();
            date.setDate(date.getDate() + parseInt(completionDays, 10));
            var options = { year: "numeric", month: "long", day: "numeric" };
            estimatedCompletionDate = date.toLocaleDateString("en-AU", options);
          }

          // #302: a Ready-to-Ship variant is in stock — show "Ready to ship"
          // instead of the made-to-order completion date on this line.
          var readyToShip = false;
          var rtsIds = rtsVariantMap[product.handle];
          var lineVariantId = product.variant_id || product.id;
          if (rtsIds && rtsIds.indexOf(lineVariantId) !== -1) {
            readyToShip = true;
            estimatedCompletionDate = null;
          }

          item = {
            key: product.key,
            url: product.url,
            img: prodImg,
            name: product.product_title,
            variation: variant,
            variantOptions: variantOptions,
            singleVariantOption: variantOptions.length === 1 ? variantOptions[0] : null,
            hasProperties: product.properties ? Object.values(product.properties).some(function(v) { return !!v; }) : false,
            showDetails: variantOptions.length !== 1 || (product.properties ? Object.values(product.properties).some(function(v) { return !!v; }) : false),
            properties: product.properties,
            itemQty: product.quantity,
            price: theme.Currency.formatMoney(
              product.price,
              theme.settings.moneyFormat,
            ),
            unitPrice: theme.Currency.formatMoney(
              product.unit_price,
              theme.settings.moneyFormat,
            ),
            unitBase: theme.Currency.getBaseUnit(product),
            discountedPrice: theme.Currency.formatMoney(
              product.price - product.total_discount / product.quantity,
              theme.settings.moneyFormat,
            ),
            discounts: product.line_level_discount_allocations,
            discountsApplied:
              product.line_level_discount_allocations.length === 0
                ? false
                : true,
            vendor: product.vendor,
            estimatedCompletionDate: estimatedCompletionDate,
            readyToShip: readyToShip,
            isPartialPayment: isPartialPayment,
            depositPrice: depositAmount
              ? theme.Currency.formatMoney(
                  depositAmount,
                  theme.settings.moneyFormat,
                )
              : null,
          };

          items.push(item);
        });

        var empty = "";

        if (settingArr.length > 0 && 1 == 2) {
          var emptyArr = __this.emptySettings(settingArr, stoneArr);

          if (emptyArr.length > 0) {
            $("#cart-warning").addClass("active");
            for (var x = 0; x < emptyArr.length; x++) {
              if (x > 0) empty += ", ";
              empty += emptyArr[x];
            }
          } else {
          }
        }

        // If we have cart discount, add a formattedAmount to the discount object

        var cartAmount = 0;

        data = {
          empty: empty,
          items: items,
          note: cart.note,
          cartDiscounts: cart.cart_level_discount_applications,
          cartDiscountsApplied:
            cart.cart_level_discount_applications.length === 0 ? false : true,
          totalPrice: theme.Currency.formatMoney(
            cart.total_price,
            theme.settings.moneyFormat,
          ),
          checkoutChargeAmount: theme.Currency.formatMoney(
            actualTotal,
            theme.settings.moneyFormat,
          ),
        };

        $(__this.selectors.container).append(__this.template(data));

        //if(empty!='') $('#cart-warning').addClass('active');
        if (settingArr.length && !stoneArr.length)
          $("#cart-warning").addClass("active");

        __this.status.loaded = true;
        __this.loading(false);

        $("body").trigger("updateCart" + __this.config.namespace, cart);
        $("#cart_count").text(cart.item_count);
        if (window.location.href.indexOf("/cart") > -1) __this.toggleCart();
      }); // end $.when.then
    }
  }
  emptySettings(settingArr, stoneArr) {
    var testArr = [];
    var emptyArr = [];

    var stones = theme.settings.shapeList.split(",");

    settingArr.forEach((setting) => {
      var title = setting.toLowerCase();
      stones.forEach((stone) => {
        if (title.indexOf(stone.toLowerCase()) > -1) {
          testArr.push([setting, stone]);
        }
      });
    });

    testArr.forEach((test) => {
      var title = test[1].toLowerCase();

      stones.forEach((stone) => {
        if (title === stone.toLowerCase()) {
          emptyArr.push(test[0]);
        }
      });
    });

    return emptyArr;
  }
  initQtySelectors() {
    var __this = this;

    $(this.selectors.container)
      .find(".js-qty__wrapper")
      .each(
        function (index, el) {
          var selector = new QtySelector($(el), {
            namespace: ".cart-drawer",
          });
        }.bind(this),
      );

    $("body").on("qty.cart-drawer", this.updateItem.bind(this));
  }

  updateItem(evt, key, qty) {
    if (this.status.loading) {
      return;
    }

    this.loading(true);

    theme.cart
      .changeItem(key, qty)
      .then(
        function (cart) {
          this.updateSuccess(cart);
        }.bind(this),
      )
      .catch(
        function (XMLHttpRequest) {
          this.updateError(XMLHttpRequest);
        }.bind(this),
      )
      .always(
        function () {
          this.loading(false);
        }.bind(this),
      );
  }

  loading(state) {
    this.status.loading = state;

    if (state) {
      $(this.selectors.container).addClass("is-loading");
    } else {
      $(this.selectors.container).removeClass("is-loading");
    }
  }

  emptyCart() {
    $(this.selectors.container).empty();
  }

  updateSuccess(cart) {
    if ($("body").is(".template-cart")) location.reload();
    else this.buildCart(cart);
  }

  updateError(XMLHttpRequest) {
    if (
      XMLHttpRequest.responseJSON &&
      XMLHttpRequest.responseJSON.description
    ) {
      // console.warn(XMLHttpRequest.responseJSON.description);
    }
  }

  updateCartNotification(evt, cart) {
    if (cart.items.length > 0) {
      $(this.selectors.cartBubble).addClass("cart-link__bubble--visible");
    } else {
      $(this.selectors.cartBubble).removeClass("cart-link__bubble--visible");
    }
  }
}

class FilterState {
  constructor() {
    var __this = this;

    this.btnClass = ".filter-buttons li";
    this.filterClass = ".cc-product-filter";
    this.formClass = "> .wrapper";
    this.sortBtn = '[data-button="sort"]';

    this.initFilter();

    $(window).on("scroll", function () {});
    $(window).on("filterComplete reinitFilter", function () {
      __this.initFilter();
    });
  }

  initFilter() {
    var __this = this;

    this.btn = $(this.btnClass);
    this.filter = $(this.filterClass);
    this.filterInner = this.filter.find(this.formClass);

    this.btn.off("click");
    this.btn.on("click", function () {
      __this.runClick($(this));
    });

    this.setHeight();
  }

  runClick(el) {
    var __this = this;
    if (el.is('[data-button="sort"]')) {
      if ($("body").is('[data-filter="sort"]')) {
        $("body").removeAttr("data-filter");
      } else {
        $("body").attr("data-filter", "sort");
      }
    } else {
      if ($("body").is('[data-filter="filter"]')) {
        $("body").removeAttr("data-filter");
      } else {
        $("body").attr("data-filter", "filter");
      }
      //$('body').trigger('scroll');
    }
    this.setHeight();
  }

  setHeight() {
    if ($("body").is('[data-filter="filter"]')) {
      var filterTop = this.filter.position().top;
      var filterInner = this.filterInner.outerHeight();
      var filterTotal = filterTop + filterInner;
    } else {
      var filterTop = this.filter.position().top;
      var filterInner = 0;
      var filterTotal = filterTop;
    }

    document.documentElement.style.setProperty("--box-top", filterTop + "px");
    document.documentElement.style.setProperty(
      "--box-offset",
      filterInner + "px",
    );
    document.documentElement.style.setProperty(
      "--box-total",
      filterTotal + "px",
    );
  }
}

class BoxScroll {
  constructor(boxClass, elClass, stopClass) {
    var __this = this;

    this.boxClass = boxClass;
    this.elClass = elClass;
    this.stopClass = stopClass;

    this.setupElements();

    $(window).on("scroll resize load headerComplete", function () {
      __this.runScroll();
    });
    // Set data-header-complete attribute on both load and headerComplete events
    // to prevent filters from staying invisible if header completes before page fully loads
    $(window).on("load headerComplete", function () {
      $("body").attr("data-header-complete", 1);
    });

    $(window).on("reinitFilter", function () {
      __this.setupElements();
    });
    this.runScroll();
  }

  setupElements() {
    var __this = this;

    this.box = $(this.boxClass).first();
    this.el = $(this.elClass).first();

    this.lastEl = this.el.find("> *").first();
    this.stopEl = $(this.stopClass);
    this.scrollPos = $(window).scrollTop();

    this.runScroll();
  }

  updateStop(stop) {
    this.stopEl = stop;

    this.runScroll();
  }

  runScroll() {
    var __this = this;

    this.scrollPos = $(window).scrollTop();
    this.scrollPos = this.scrollPos < 0 ? 0 : this.scrollPos;

    var filterHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--box-offset",
      ),
    );

    var elTop = this.box.offset().top;

    var top = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--nav-height",
      ),
    );

    var intTop = elTop - top;

    var bottom = intTop + this.stopHeight() - this.boxHeight();
    this.el.width(this.el.parent().outerWidth());
    if (this.scrollPos < intTop) {
      this.el.css("transform", "translate(0, 0)");
      this.el.removeClass("fixed");
    } else if (this.scrollPos > bottom) {
      this.el.css("transform", "translate(0, " + bottom + "px)");
      this.el.removeClass("fixed");
    } else {
      this.el.css("transform", "translate(0, " + top + "px)");
      this.el.addClass("fixed");
    }
  }

  stopHeight() {
    var height = $(this.stopEl).offset().top + $(this.stopEl).outerHeight();
    return height;
  }

  boxHeight() {
    var height = this.lastEl.position().top + this.lastEl.outerHeight();
    return height;
  }
}

class ProductScroll {
  constructor(boxEl, el) {
    var __this = this;

    /*
    this.boxClass = boxClass;
    this.elClass = elClass;
    */

    this.setupElements(boxEl, el);
    this.runScroll();

    $(window).on("scroll resize load", function () {
      __this.runScroll();
    });
  }

  setupElements(boxEl, el) {
    var __this = this;

    this.box = boxEl;
    this.el = el;

    this.lastEl = this.el.find("> *").first();
    this.scrollPos = $(window).scrollTop();

    this.runScroll();
  }

  runScroll() {
    var __this = this;

    this.scrollPos = $(window).scrollTop();

    var boxTop = this.box.offset().top;
    var boxHeight = this.box.outerHeight();

    var elHeight = this.boxHeight();

    var navTop = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "--nav-height",
      ),
    );
    var elTrack = boxHeight - elHeight;
    var boxBottom = boxTop + elTrack;

    var intTop = boxTop - navTop;
    var intBottom = boxBottom - navTop;

    //if( this.el.is( '.product-form--inner' ) ) console.log( navTop + '  ' + intBottom + ' : ' + boxHeight )

    if (this.scrollPos < intTop) {
      this.el.css("transform", "translate(0, 0)");
      this.el.removeClass("fixed");
      this.el.removeClass("absolute");
    } else if (this.scrollPos > intBottom) {
      this.el.css("transform", "translate(0, 0)");
      this.el.removeClass("fixed");
      this.el.addClass("absolute");
    } else {
      this.el.css("transform", "translate(0, " + navTop + "px)");
      this.el.addClass("fixed");
      this.el.removeClass("absolute");
    }
  }

  boxHeight() {
    //var height = this.lastEl.position().top + this.lastEl.outerHeight(  );
    height = this.el.outerHeight();
    return height;
  }
}

class ProxyTag {
  constructor(el) {
    var __this = this;
    this.rootEl = el;
    this.setupProxy();
    $(window).on("filterComplete", function () {
      __this.setupProxy();
      //lenis.stop();
      //lenis.start();
    });
  }

  setupProxy() {
    var __this = this;

    this.el = this.rootEl.clone();

    this.inputName = '[name*="filter.p.tag"]';
    this.inputSelect = ".cc-checkbox__input" + this.inputName + "";
    this.input = $(this.inputSelect);

    this.form = $("#FacetsForm .cc-product-filter .display--flex");
    this.tag = this.el.find(".cc-checkbox-proxy");
    this.sort = $(".cc-product-filter__sort-by");

    this.baseEl = $(this.inputName).first().closest(".filter-column");
    this.baseEl.hide();

    this.el.appendTo(this.form);

    this.setupRel();
    this.checkAvailable();

    this.tag.on("click", function () {
      $(this).data("rel").parent().trigger("click");
      __this.checkActive($(this));
    });

    $(window).trigger("reinitFilter");
  }

  checkAvailable() {
    var __this = this;
    this.tag.each(function () {
      if ($(this).data("rel").length) {
        $(this).removeClass("unavailable");
        var cnt = $(this).data("rel").siblings(".cc-checkbox__count");
        if (cnt.length) cnt.clone().appendTo($(this));
      } else {
        $(this).addClass("unavailable");
      }
    });

    if (!this.el.find(".cc-checkbox-proxy:not(.unavailable)").length) {
      this.el.hide();
    }
  }

  checkActive(el) {
    if (el.data("rel").is(":checked")) {
      el.addClass("active");
    } else {
      el.removeClass("active");
    }
  }

  setupRel() {
    var __this = this;
    this.input.each(function () {
      $(this).attr("data-value", $(this).attr("value").toLowerCase());
    });

    this.tag.each(function () {
      var val = $.trim($(this).text().split(" -- ")[0]).toLowerCase();
      $(this).attr("value", val);
      var elRel = $(__this.inputSelect + '[data-value="' + val + '"]');
      $(this).data("rel", elRel);
      __this.checkActive($(this));
    });
  }
}

class ProxySwatch {
  constructor() {
    var __this = this;

    this.rootEl = $(".proxy--swatch").first();

    this.setupProxy();

    $(window).on("filterComplete", function () {
      __this.setupProxy();
    });
  }

  setupProxy() {
    var __this = this;

    this.el = this.rootEl.clone();
    this.inputSelect = '.cc-checkbox__input[name*="custom.swatch"]';
    this.input = $(this.inputSelect);
    this.form = $("#FacetsForm");
    this.swatch = this.el.find(".cc-checkbox-proxy");
    this.sort = $(".cc-product-filter__sort-by");

    this.el.appendTo(this.form);

    this.baseEl = $('[name*="custom.swatch"]')
      .first()
      .closest(".filter-column");
    this.baseEl.hide();

    this.setupRel();

    this.checkAvailable();

    this.swatch.on("click", function () {
      $(this).data("rel").parent().trigger("click");

      __this.checkActive($(this));
    });

    $(window).trigger("reinitFilter");
  }

  checkAvailable() {
    var __this = this;

    this.swatch.each(function () {
      if ($(this).data("rel").length) $(this).removeClass("unavailable");
      else {
        $(this).addClass("unavailable");
      }
    });

    if (!this.el.find(".cc-checkbox-proxy:not(.unavailable)").length) {
      this.el.hide();
    }
  }

  checkActive(el) {
    if (el.data("rel").is(":checked")) {
      el.addClass("active");
    } else {
      el.removeClass("active");
    }
  }

  setupRel() {
    var __this = this;

    this.input.each(function () {
      $(this).attr("data-value", $(this).attr("value").toLowerCase());
    });

    this.swatch.each(function () {
      var val = $.trim($(this).text().split(" -- ")[0]).toLowerCase();

      $(this).attr("value", val);

      var elRel = $(__this.inputSelect + '[data-value="' + val + '"]');

      $(this).data("rel", elRel);

      __this.checkActive($(this));
    });
  }
}

class StickElement {
  constructor(root, el, scroll, distance) {
    var __this = this;

    this.root = root;

    this.el = el;

    this.scroll = scroll;

    this.distance = distance;

    this.scrollPos = $(window).scrollTop();

    this.elTop = this.el.offset().top;

    this.windowHeight = $(window).innerHeight();

    $(window).on("resize", function () {
      __this.elTop = __this.el.offset().top;
      __this.windowHeight = $(window).innerHeight();
    });

    $(window).on("scroll", function () {
      __this.scrollPos = $(window).scrollTop();

      __this.runScroll();
    });
  }

  updateDistance(distance) {
    this.distance = distance;
    this.elTop = this.el.offset().top;
  }

  returnMid(el) {
    return el.offset().left + el.outerWidth() / 2;
  }

  runScroll() {
    var __this = this;

    var calcDistance = this.scrollPos - this.elTop;
    var finalDistance = this.elTop + this.distance;

    if (this.scrollPos + this.windowHeight >= this.el.offset().top) {
      this.root.updateScroll();
    }

    if (
      this.scrollPos >= this.elTop &&
      this.scrollPos < this.elTop + this.distance
    ) {
      this.scroll.css("transform", "translate3d( 0px, 0px, 0px )");

      this.scroll.addClass("fixed");
    } else if (this.scrollPos < this.elTop) {
      this.scroll.removeClass("fixed");

      this.scroll.css("transform", "translate3d( 0px, 0px, 0px )");
    } else {
      this.scroll.css(
        "transform",
        "translate3d( 0, " + this.distance + "px, 0px )",
      );

      this.scroll.removeClass("fixed");
    }
  }
}

class InstagramFeed {
  constructor() {
    var __this = this;

    this.testCounter = 0;
    this.testTimeout = 3500;
    this.testLimit = 5;

    this.elClass = ".fs-timeline";

    this.base = $(".instagram-feed");
    this.scroll = this.base.find(".testing").first();

    this.runTimer();

    $(window).on("resize, retrigger", function () {
      __this.updateScroll();
    });

    $("body").on("load", function () {
      __this.updateScroll();
    });
  }

  updateScroll() {
    var __this = this;
    if (typeof $.data(__this.scroll, "scroll") != "undefined") {
      var distance = this.el.outerHeight() - this.scroll.height();
      $.data(__this.scroll, "scroll").updateDistance(distance);
    }
  }

  runTimer() {
    var __this = this;
    if (this.testCounter < this.testLimit)
      setTimeout(function () {
        __this.testInstagram();
      }, __this.testTimeout);
  }

  testInstagram() {
    var __this = this;
    if ($(this.elClass).length) this.setupInstagram();
    else {
      this.testCounter++;
      runTimer();
    }
  }

  setupInstagram() {
    var __this = this;
    this.el = $(this.elClass);
    this.block = this.el.find("> *");
    this.distance = this.el.height() - this.scroll.height();
  }
}

class ClothesHR {
  constructor(el) {
    var __this = this;

    this.el = el;

    this.flex = this.el.find(".clothes-hr-flex");

    this.block = this.flex.find("> div").first();

    this.blockWidth = 0;
    this.prevScroll = $(window).scrollTop();
    this.currPos = 0;
    this.distance = 0.25;

    this.timeZoneCheck();
  }

  timeZoneCheck() {
    var __this = this;

    if ($("body").is("[data-timezone]")) {
      this.setupSection();
    } else {
      $(window).on("timezone", function () {
        __this.setupSection();
      });
    }
  }

  setupSection() {
    var __this = this;

    this.blockWidth = this.block.first().outerWidth();

    for (var x = 0; x < 3; x++) {
      this.block.first().clone().appendTo(this.flex);
    }

    this.interval = setInterval(function () {
      __this.runSection();
    }, 50);
  }

  runSection() {
    var __this = this;

    var currScroll = $(window).scrollTop();
    var extra = Math.abs(currScroll - this.prevScroll) / 12;
    var newPos = this.currPos - extra - this.distance;

    var overflow = newPos + this.block.first().outerWidth();

    newPos = overflow < 0 ? overflow : newPos;

    this.flex.css("transform", "translate(" + newPos + "px, 0)");

    this.prevScroll = currScroll;
    this.currPos = newPos;

    // if( overflow < 0 ) { clearInterval( this.interval ); console.log( 'over ' + overflow ); }
  }
}

class ClothesThatLogo {
  constructor() {
    var __this = this;

    this.el = $(".clothes-logo");

    this.timer = null;

    if (this.el.length < 2) {
      $(window).on("headerDuplicated", function () {
        __this.setupLogo();
      });
    } else {
      this.setupLogo();
    }
  }

  setupLogo() {
    var __this = this;

    this.el = $('.clothes-logo [data-section-type="clothes-that-travel"]');
    this.elArray = $(
      '.scroll-banner--clothes h2 [data-section-type="clothes-that-travel"], #page-content .clothes-hr-container',
    );
    this.scrollPos = $(window).scrollTop();

    this.timeZoneCheck();
  }

  checkVisibility() {
    var __this = this;

    var isVisible = 1;

    this.elArray.each(function () {
      var elPos = $(this).offset().top + $(this).outerHeight() / 2;
      var top = __this.scrollPos;
      var bottom = $(window).innerHeight() + top;

      if (elPos > top && elPos < bottom) isVisible = 0;
    });

    if (isVisible) {
      if (!this.el.is(".active")) {
        this.el.addClass("active");

        this.startTimeZone();
      }
    } else {
      if (this.el.is(".active")) {
        this.el.removeClass("active");

        this.endTimeZone();
      }
    }
  }

  timeZoneCheck() {
    var __this = this;

    if ($("body").is("[data-timezone]")) {
      this.setupTimeZone();
    } else {
      $(window).on("timezone", function () {
        __this.setupTimeZone();
      });
    }
  }

  setupTimeZone() {
    var __this = this;
    this.timeZone = this.el.first().find("> *");
    this.timeZoneCount = this.timeZone.length;
    this.counter = 1;

    this.checkVisibility();

    $(window).on("scroll", function () {
      __this.scrollPos = $(window).scrollTop();

      __this.checkVisibility();
    });
  }

  startTimeZone() {
    this.counter = 0;

    this.runTimeZone();
  }

  endTimeZone() {
    clearTimeout(this.timer);
  }

  runTimeZone() {
    var __this = this;

    var reTimer = 0;

    this.el.each(function () {
      var currEl = $(this).find("> *").eq(__this.counter);

      currEl.addClass("start").addClass("active");

      currEl[0].offsetHeight;

      currEl.removeClass("start").siblings().removeClass("active");

      reTimer = currEl.is(".base") ? 8000 : 2500;
    });

    this.counter = (this.counter + 1) % this.timeZoneCount;

    this.timer = setTimeout(function () {
      __this.runTimeZone();
    }, reTimer);
  }
}

class ClothesThatTravel {
  constructor() {
    var __this = this;
    this.isInit = 0;
    this.timezones = $("meta[data-timezone]");
    this.elements = $('[data-section-type="clothes-that-travel"]');

    this.elements.each(function () {
      __this.setElements($(this));
    });

    $("body").attr("data-timezone", 1);
    $(window).trigger("timezone");

    this.runTimeZone();
    setInterval(function () {
      __this.runTimeZone();
    }, 1000);
  }

  setElements(el) {
    var __this = this;

    this.timezones.each(function () {
      var intEl = $(
        '<span class="timezone" data-value="' +
          $(this).attr("data-location").toLowerCase() +
          '"></span>',
      );
      intEl.appendTo(el);
    });

    el.attr("data-timezone-init", true);
  }

  runTimeZone() {
    var __this = this;

    var baseTime = new Date();

    this.timezones.each(function () {
      var optionsDay = {
        timeZone: $(this).attr("data-timezone"),
        weekday: "short",
      };
      var optionsDate = {
        timeZone: $(this).attr("data-timezone"),
        month: "short",
        day: "numeric",
      };
      var optionsTime = {
        timeZone: $(this).attr("data-timezone"),
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hourCycle: "h23",
      };

      var day = baseTime.toLocaleString("en-AU", optionsDay);
      var date = baseTime.toLocaleString("en-AU", optionsDate);
      var time = baseTime.toLocaleString("en-AU", optionsTime);

      var el = $(
        '[data-value="' + $(this).attr("data-location").toLowerCase() + '"]',
      );

      el.html(
        '<b class="location">' +
          $(this).attr("data-location") +
          '</b><b class="day">' +
          day +
          '</b><b class="date">' +
          date +
          '</b><b class="time">' +
          time +
          "</b>",
      );

      if (!this.isInit) {
        el.each(function () {
          $(this).width($(this).outerWidth());
        });
      }
    });

    this.isInit = 1;
  }
}

class AutoScrollBanner {
  constructor(el) {
    var __this = this;

    this.el = el;
    this.container = this.el.find(".scroll-banner--flex");
    this.box = this.el.find(".scroll-banner--box");
    this.cursor = this.el.find(".cursor");

    this.blockWidth = 0;
    this.prevScroll = $(window).scrollTop();
    this.currPos = 0;
    this.distance = 0.5;
    this.token = 0;
    this.finalX = 0;
    this.finalY = 0;
    this.finalOpacity = 0;
    this.currX = 0;
    this.currY = 0;
    this.currOpacity = 0;
    this.clearTimer = null;

    this.initPosition();
    this.initValues();
    this.initImg();

    this.scrollPos = $(window).scrollTop();

    $(window).resize(function () {
      __this.initValues();
    });

    this.el.hover(
      function () {
        __this.finalOpacity = 1;
      },
      function () {
        __this.finalOpacity = 0;
      },
    );

    $(window).on("scroll", function () {
      //__this.finalOpacity=0;

      if (__this.el.is("[data-visible]")) {
        if (__this.interval == null)
          __this.interval = setInterval(function () {
            __this.runSection();
          }, 36);
      } else {
        if (__this.interval != null) {
          clearInterval(__this.interval);
          __this.interval = null;
        }
      }
    });
    this.el.on("mousemove", function (e) {
      __this.finalX = e.pageX;
      __this.finalY = e.pageY;
    });

    this.interval = setInterval(function () {
      __this.runSection();
    }, 36);
  }

  initImg() {
    var __this = this;

    this.el.find("img").each(function () {
      if (this.complete) __this.loadImg($(this));
      else {
        $(this).on("load", function () {
          __this.loadImg($(this));
        });
      }
    });
  }

  loadImg(el) {
    el.closest(".scroll-banner--item").attr("data-complete", 1);
  }

  initPosition() {
    var __this = this;

    this.box.clone().appendTo(this.container);

    this.el.find(".scroll-banner--item a").hover(
      function () {
        var intEl = $(this).find(".product-item").clone();
        intEl.addClass("banner-product");

        intEl.addClass("start").appendTo(__this.cursor);

        intEl[0].offsetHeight;

        intEl.removeClass("start").addClass("active");

        //__this.finalOpacity=1;

        __this.cursor.addClass("active");
      },
      function () {
        //__this.finalOpacity=0;

        clearTimeout(__this.clearTimer);

        __this.cursor.find(".active").addClass("end");

        __this.clearTimer = setTimeout(function () {
          __this.cursor.find(".end").remove();
        }, 1000);

        __this.cursor.removeClass("active");
      },
    );
  }

  initValues() {
    var __this = this;

    this.boxWidth = this.box.width();
    this.negativeBoxWidth = -1 * this.boxWidth;
    this.container.width(this.boxWidth * 2);
  }

  runSection() {
    var __this = this;

    var currScroll = $(window).scrollTop();
    var extra = Math.abs(currScroll - this.prevScroll) / 12;
    var newPos = this.currPos - extra - this.distance;

    var overflow = newPos + this.box.first().outerWidth();

    newPos = overflow < 0 ? overflow : newPos;

    this.container.css("transform", "translate(" + newPos + "px, 0)");

    this.prevScroll = currScroll;
    this.currPos = newPos;

    this.lerper();
  }

  lerper() {
    var intX = this.currX + (this.finalX - this.currX) * 0.125;
    var intY = this.currY + (this.finalY - this.currY) * 0.125;
    var intOpacity =
      this.currOpacity + (this.finalOpacity - this.currOpacity) * 0.125;

    this.el
      .find(".cursor")
      .css("position", "absolute")
      .css("top", intY)
      .css("left", intX)
      .css("opacity", intOpacity)
      .css("pointer-events", "none");

    this.currX = intX;
    this.currY = intY;
    this.currOpacity = intOpacity;
  }
}

class ScrollBanner {
  constructor(el) {
    var __this = this;

    this.el = el;

    this.mode = this.el.find("[data-section-mode]").attr("data-section-mode");

    this.elScroll = this.el.find(".scroll-banner--container");
    this.elWrapper = this.el.find(".scroll-banner--wrapper");
    this.elFlex = this.el.find(".scroll-banner--flex");
    this.elBlock = this.el.find(".scroll-banner--item");
    this.blockLength = this.elBlock.length;
    this.elContent = this.el.find(".scroll-banner--content");
    this.elTop = 0;
    this.distance = 0;
    this.scrollPos = $(window).scrollTop();
    this.index = 1;
    this.h3 = this.el.find("h3");
    this.contentInit = 0;
    this.headingInit = 0;

    if (this.mode == "reveal") {
      this.elFlexReveal = this.elFlex.clone().insertBefore(this.elScroll);
      this.elFlexReveal
        .attr("data-proxy", "proxy")
        .addClass("scroll-banner--flex__reveal");
    }

    this.resizeTimer = null;

    this.setupImageLoading();
    this.setupWindowHeight();
    //this.setupHeights();
    this.setupContent();
    this.runScroll();
    this.setIndex();

    $(window).on("resize retrigger", function () {
      clearTimeout(__this.resizeTimer);
      __this.resizeTimer = setTimeout(function () {
        if (!isMobile) {
          __this.setupWindowHeight();
        }
      }, 250);
    });

    $(window).on("scroll", function () {
      // __this.h3.text(__this.elScroll.closest('.shopify-section').height()+ ' height');

      if (__this.elBlock.length > 1) {
        __this.scrollPos = $(window).scrollTop();
        __this.scrollPos = __this.scrollPos < 0 ? 0 : __this.scrollPos;
        __this.runScroll();
      }
    });
    this.el.find("img").on("load", function () {
      clearTimeout(__this.resizeTimer);
      __this.resizeTimer = setTimeout(function () {
        __this.setupWindowHeight();
      }, 250);
    });

    this.timeZoneCheck();
  }
  setupImageLoading() {
    var __this = this;

    this.el.find("img").each(function () {
      if ($(this)[0].complete) {
        __this.runImageLoaded($(this));
        return;
      }
      $(this).on("load", function () {
        __this.runImageLoaded($(this));
      });
    });
  }

  runImageLoaded(el) {
    var __this = this;

    el.attr("data-load", true);
  }

  setupWindowHeight() {
    var __this = this;

    if (this.mode == "reveal") this.setupRevealHeights();

    if (isMobile) this.elFlex.addClass("scroll-banner--flex__opacity");
    else {
      if (this.mode != "opacity") {
        this.elFlex.removeClass("scroll-banner--flex__opacity");
      }
    }

    this.windowHeight = $(window).innerHeight();
    document.documentElement.style.setProperty(
      "--scroll-window-height",
      this.windowHeight + "px",
    );

    this.elTop = this.el.offset().top;

    if (this.mode == "reveal") {
      var intLast = this.elFlexReveal.find(">div").last();
      var flexHeight =
        this.elFlexReveal.height() -
        intLast.height() +
        Number(intLast.attr("data-margin"));
      this.distance = flexHeight;
    } else if (this.mode == "opacity") {
      this.distance = (this.elBlock.length - 1) * $(window).height();
    } else {
      this.distance =
        this.returnMid(this.elBlock.last()) -
        this.returnMid(this.elBlock.first());
    }
    var overflow = this.elScroll.height() - this.windowHeight;
    overflow = overflow < 0 ? 0 : overflow;
    this.el.height(this.windowHeight + this.distance + overflow);
  }

  setupRevealHeights() {
    var __this = this;

    var cont = this.elFlexReveal.find(".scroll-banner--item__container");
    this.elFlexReveal.css("top", "auto");

    cont.each(function (index) {
      var rel = __this.elBlock.eq($(this).index());
      var center = rel.offset().top + rel.height() / 2;

      if (isMobile) $(this).find(">*").first().css("top", center);

      var int = $(this).find(">div");
      var intHeight = int.height();
      var index = $(this).index();

      if (index == 0) {
        var off = int.offset().top - __this.scrollPos;
        __this.elFlexReveal.css("top", off);
      }

      var intMargin = 0;
      if (index) {
        var prevHeight = $(this).prev().height();
        if (intHeight > prevHeight) {
          intMargin = (intHeight - prevHeight) / 2;
        }
      }
      $(this)
        .attr("data-margin", intMargin)
        .css("margin-top", intMargin)
        .height(int.height());

      $(this)[0].offsetHeight;

      this.siblingHeight = intHeight;
    });
  }

  timeZoneCheck() {
    var __this = this;
    if ($("body").is("[data-timezone]")) {
      this.setupTimeZone();
    } else {
      $(window).on("timezone", function () {
        __this.setupTimeZone();
      });
    }
  }

  setupTimeZone() {
    var __this = this;
    this.timeZone = this.el.find(".timezone");
    this.timeZoneCount = this.timeZone.length;
    this.counter = 0;

    this.runTimeZone();
  }

  runTimeZone() {
    var __this = this;

    this.counter = (this.counter + 1) % this.timeZoneCount;
    var currEl = this.timeZone.eq(this.counter);

    currEl.addClass("start").addClass("active");
    currEl[0].offsetHeight;
    currEl.removeClass("start").siblings().removeClass("active");

    setTimeout(function () {
      __this.runTimeZone();
    }, 4000);
  }

  setupContent() {
    var __this = this;

    if (!this.contentInit) {
      this.el.attr("data-content-init", true);
      this.contentInit = 1;
    }
  }

  setupHeights() {
    var __this = this;
  }

  returnMid(el) {
    return el.offset().left + el.outerWidth() / 2;
  }

  runScroll() {
    var __this = this;

    var calcDistance = this.scrollPos - this.elTop;
    var finalDistance = this.elTop + this.distance;

    if (
      this.scrollPos >= this.elTop &&
      this.scrollPos < this.elTop + this.distance
    ) {
      this.elFlex.css(
        "transform",
        "translate3d( -" + calcDistance + "px, 0px, 0px )",
      );
      this.elScroll.css("transform", "translate3d( 0px, 0px, 0px )");
      this.elScroll.addClass("fixed");
    } else if (this.scrollPos < this.elTop) {
      this.elFlex.css("transform", "translate3d( 0px, 0px, 0px )");
      this.elScroll.removeClass("fixed");
    } else {
      this.elFlex.css(
        "transform",
        "translate3d( -" + this.distance + "px, 0px, 0px )",
      );
      this.elScroll.css(
        "transform",
        "translate3d( 0, " + this.distance + "px, 0px )",
      );
      this.elScroll.removeClass("fixed");
    }
    var index = Math.floor(
      (this.blockLength * (this.scrollPos - this.elTop)) / finalDistance,
    );
    index = index < 0 ? 0 : index;
    index = index >= this.blockLength ? this.blockLength - 1 : index;
    if (this.blockLength == 1) this.elBlock.first().addClass("active");

    var sectionPos = (100 * (this.scrollPos - this.elTop)) / finalDistance;
    var sectionPath =
      "polygon(0 0, " +
      sectionPos +
      "% 0,  " +
      sectionPos +
      "% 100%, 0 100%, 0 0)";

    var sectionOpacity = sectionPos > 0 && sectionPos < 100 ? 1 : 0;

    document.documentElement.style.setProperty(
      "--scroll-path",
      sectionPath + "",
    );
    document.documentElement.style.setProperty(
      "--scroll-opacity",
      sectionOpacity,
    );

    if (this.index != index) {
      this.index = index;
      this.setIndex();
    }
  }

  setIndex() {
    var __this = this;
    this.elFlex
      .find("> *")
      .eq(this.index)
      .addClass("active")
      .siblings()
      .removeClass("active");
  }
}

class ScrollMenu {
  constructor() {
    var __this = this;

    this.announce = $(".cc-announcement");
    this.header = $('[data-section-type="header"] > *')
      .first()
      .find(".site-control");
    this.footer = $("footer.site-footer");

    this.headerInner = this.header.find(".site-control__inner");
    this.inner = this.announce.find(" > * ").first();
    this.scrollOffset = 600;
    this.scrollPos = $(window).scrollTop();
    this.runScroll();

    $(window).on("scroll", function () {
      __this.scrollPos = $(window).scrollTop();
      __this.runScroll();
    });
  }

  runScroll() {
    var __this = this;

    var inner = this.inner.length ? this.inner.outerHeight() : 0;
    //var total=this.headerInner.outerHeight()+inner;
    var total = inner;
    this.headerInner.each(function () {
      total += $(this).outerHeight();
    });
    var pageMin = $(window).height() - total - this.footer.outerHeight();

    document.documentElement.style.setProperty(
      "--header-total-height",
      total + "px",
    );
    document.documentElement.style.setProperty(
      "--page-min-height",
      pageMin + "px",
    );
    document.documentElement.style.setProperty("--header-final", inner + "px");
    document.documentElement.style.setProperty(
      "--nav-final",
      this.headerInner.outerHeight() + "px",
    );

    if (this.scrollPos > this.scrollOffset) {
      document.documentElement.style.setProperty("--header-height", "0px");
      document.documentElement.style.setProperty(
        "--nav-height",
        this.header.outerHeight() + "px",
      );
    } else {
      document.documentElement.style.setProperty(
        "--header-height",
        inner + "px",
      );
      var totalHeight = this.header.outerHeight();
      document.documentElement.style.setProperty(
        "--nav-height",
        totalHeight + "px",
      );
    }
  }
}

class DropDown {
  constructor(el, nav) {
    var __this = this;
    this.el = el;
    this.header = this.el.find(".drop--down__header");
    this.findElClass = ".site-control__inline-links a";
    this.find = $(this.findElClass);
    this.findClass = "[data-dropdown-related]";

    this.nav = nav.clone();
    if (!this.el.is(".theme--light")) this.nav.addClass("site-header--dark");
    this.nav.appendTo(this.header);
    this.nav.find(".cc-announcement").remove();
    this.nav.find(".fixed").removeClass("fixed");
    this.nav.removeClass("fixed");

    this.btnArray = [];

    this.setupRelated();

    $("body").on("click", function (e) {
      var el = $(e.target);
      if (!__this.btnArray.length) return;

      if (__this.willToggle(el)) {
        e.preventDefault();
        __this.toggleDropDown();
      }
    });

    this.setupTaglines();
    $(window).on("resize, load", function () {
      __this.setupTaglines();
    });
  }

  setupTaglines() {
    var __this = this;
    var tag = this.el.find(".dropdown-column .tagline");
    var min = 0;
    tag.each(function () {
      $(this).css("min-height", 0);
      $(this)[0].offsetHeight;
      var testMin = $(this).outerHeight();
      min = testMin > min ? testMin : min;
      min = 0;
    });
    tag.each(function () {
      $(this).css("min-height", min + "px");
    });
  }

  willToggle(el) {
    var __this = this;

    var toggle = 0;

    if (
      !el.closest('[data-section-type="dropdown"]').length &&
      this.el.is("[data-active]")
    )
      toggle = 1;
    //if(el.is(this.findClass)||el.closest(this.findClass).length) toggle=1;

    $.each(__this.btnArray, function (index, value) {
      if (el.is(value) || el.closest("a").is(value)) toggle = 1;
    });

    return toggle;
  }

  setupRelated() {
    var __this = this;
    this.rel = this.el.attr("data-related").toLowerCase();

    this.related = null;
    var elEq = 0;

    this.find.each(function () {
      var compare = $.trim($(this).text().toLowerCase());

      if (compare == __this.rel) {
        __this.related = $(this);
        __this.btnArray[__this.btnArray.length] = $(this);
        $(this).attr("data-dropdown-related", "true");
        $(this).data("related", __this.el);
        var eq = $(this).parent().index();
        __this.nav
          .find(__this.findElClass)
          .eq(eq)
          .attr("data-dropdown-proxy", true)
          .addClass("current");
      }
    });

    if (this.related == null) return;

    /*
    $(this.findClass).on('click', function(e){
      e.preventDefault();
      __this.toggleDropDown();
    })
    */
  }

  toggleDropDown() {
    var __this = this;

    if (this.el.is("[data-active]")) this.el.removeAttr("data-active");
    else this.el.attr("data-active", "active");
  }
}

class ScrollClass {
  constructor() {
    var __this = this;

    this.sizeTimer = null;

    this.navClass = ".site-control__inline-links";

    this.sections = $("#page-content .shopify-section");
    this.header = $('[data-section-type="header"]');
    this.header.css("padding", "0");
    this.footer = $('[data-section-type="footer"]');
    this.elLight = $(".site-header--light");
    this.elLightContainer = this.elLight.parent();
    this.elDarkContainer = this.elLightContainer.clone().appendTo(this.header);
    this.elDark = this.elDarkContainer.find(".site-header--light");
    this.elDark.find("#site-control").removeAttr("id");

    this.pathCnt = 0;

    $(".drop--down").each(function () {
      $(this).data("dropdown", new DropDown($(this), __this.elDark));
    });

    this.elDark
      .clone()
      .addClass("site-header--dark")
      .prependTo("#page-menu")
      .find("#site-control")
      .removeAttr("id");

    $(window).trigger("headerDuplicated");

    this.darkArray = [];
    this.lightArray = [];

    this.darkMatrix = [];
    this.lightMatrix = [];

    this.scrollPos = $(window).scrollTop();

    this.setItems();

    // calculates

    if (this.darkArray.length) {
      this.continueItems();
    } else {
      this.elDark.hide();
    }

    setTimeout(function () {
      __this.elLight.attr("data-init", true);
      __this.elDark.attr("data-init", true);
    }, 125);

    this.setupDropDownProxy();
    this.setupHoverProxy();
    this.setupIcons();

    $(window).trigger("headerComplete");
  }

  setupIcons() {
    var __this = this;
    $(this.navClass)
      .find("[data-dropdown-related],[data-dropdown-proxy]")
      .each(function () {
        $(
          '<span class="icon icon--smaller">' + iconChevronDown() + "</span>",
        ).appendTo($(this));
      });
  }

  setupHoverProxy() {
    var __this = this;

    $(this.navClass).each(function () {
      $(this)
        .find("a")
        .each(function (index) {
          $(this).attr("data-hover-proxy", index);
        });
    });
    $("[data-hover-proxy]").hover(
      function () {
        $('[data-hover-proxy="' + __this.returnEq($(this)) + '"]').addClass(
          "hover",
        );
      },
      function () {
        $('[data-hover-proxy="' + __this.returnEq($(this)) + '"]').removeClass(
          "hover",
        );
      },
    );
  }

  returnEq(el) {
    return el.attr("data-hover-proxy");
  }

  setupDropDownProxy() {
    var __this = this;

    this.lightDrop = this.elLight.find(".contains-children");
    this.darkDrop = this.elDark.find(".contains-children");

    for (var x = 0; x < this.lightDrop.length; x++) {
      this.lightDrop.eq(x).data("rel", this.darkDrop.eq(x));
      this.darkDrop.eq(x).data("rel", this.lightDrop.eq(x));
    }

    this.runDropDownProxy(this.lightDrop);
    this.runDropDownProxy(this.darkDrop);
  }

  runDropDownProxy(el) {
    var __this = this;

    el.hover(
      function () {
        $(this).data("rel").addClass("hover");
      },
      function () {
        $(this).data("rel").removeClass("hover");
      },
    );
  }

  continueItems() {
    var __this = this;

    this.setLimits();

    $(window).on("resize retrigger load", function () {
      clearTimeout(__this.sizeTimer);
      __this.sizeTimer = setTimeout(function () {
        __this.setLimits();
        __this.setPaths();
      }, 2500);
    });

    $(window).on("scroll", function () {
      //__this.scrollPos=$(window).scrollTop();
      //__this.setPaths();
    });
  }

  setItems() {
    var __this = this;

    var itemArray = [];
    this.sections.each(function () {
      /*
      
      if($(this).find('.is--dark').length){
        $(this).addClass('is--dark')
      }
      
      if($(this).is('.section-clothes-that-travel-hr.is-dark')){
        $(this).addClass('is--dark')
      }
      
      */

      if ($(this).find(".is--dark").length) $(this).addClass("has--dark");
    });

    // this finds elements

    this.sections.each(function () {
      itemArray = [];

      if ($(this).is(".is--dark")) {
        __this.darkArray.push($(this));
      } else {
        var el = $(this).find(".is--dark");
        el.each(function () {
          __this.darkArray.push($(this));
        });
      }

      /*
      
      if(!itemArray.length) {
        
        if($(this).is('.section-text-overlay')){
          var el=$(this).find('.text-overlay.is-dark');
          if(el.length) {
            itemArray.push(el);
            __this.darkArray.push(itemArray);
          }
          
        }else if($(this).is('.section-text-columns-with-images')){
          var el=$(this).find('.text-column.is-dark');
          
          if(el.length) {
            el.each(function(){
              itemArray.push($(this));
              __this.darkArray.push(itemArray);
              itemArray=[];
            });
          } 
        }else {
          if($(this).is('.is--dark') ){
            itemArray.push($(this));
            __this.darkArray.push(itemArray);
          }
        }
      }
      */
    });
  }

  setLimits() {
    var __this = this;

    /*
      this.darkMatrix=[];
      this.lightMatrix=[];
    */

    this.setPaths();
  }

  setPaths() {
    var __this = this;

    var lightPath = "0% 0%, ";
    var darkPath = "0% 0%, ";

    var lastBottom = 0;
    var lastTop = 0;

    var isInit = 0;

    this.sections.each(function (index) {
      var el = $(this);

      var top = $(this).offset().top;
      var bottom = top + $(this).outerHeight();

      /*
      
      if(!index){
        if(!$(this).is('.is--dark')&&!$(this).is('.has--dark')){
          top=0;
        }
      }else{
      
        if($(this).is('.is--dark')||$(this).is('.has--dark')){
          if(!isInit) {
            isInit=1;
            lightPath+='0% 0%, 100% 0%, 100% '+top+'px, 0% '+top+'px, ';
          }
        }
      }
      
      */

      if (!index) top = 0;

      if ($(this).is(".is--dark")) {
        darkPath +=
          "0% " +
          top +
          "px, 100% " +
          top +
          "px, 100% " +
          bottom +
          "px, 0% " +
          bottom +
          "px, ";
      } else if ($(this).is(".has--dark")) {
        lightPath +=
          "0% " +
          top +
          "px, 100% " +
          top +
          "px, 100% " +
          bottom +
          "px, 0% " +
          bottom +
          "px, 0% " +
          top +
          "px, ";

        el.find(".is--dark").each(function () {
          var elTop = $(this).offset().top;
          var elBottom = elTop + $(this).outerHeight();
          var elLeft = $(this).offset().left;
          var elRight = elLeft + $(this).outerWidth();

          $(this).attr(
            "data-pos",
            elLeft + ", " + elRight + ", " + elTop + ", " + elBottom + " ---",
          );

          darkPath +=
            "0% " +
            elTop +
            "px, " +
            elLeft +
            "px " +
            elTop +
            "px, " +
            elLeft +
            "px " +
            elBottom +
            "px, " +
            elRight +
            "px " +
            elBottom +
            "px, " +
            elRight +
            "px " +
            elTop +
            "px, " +
            elLeft +
            "px " +
            elTop +
            "px, 0% " +
            elTop +
            "px, ";

          lightPath +=
            "0% " +
            top +
            "px, " +
            elLeft +
            "px " +
            top +
            "px, " +
            elLeft +
            "px " +
            elBottom +
            "px, " +
            elRight +
            "px " +
            elBottom +
            "px, " +
            elRight +
            "px " +
            elTop +
            "px, " +
            elLeft +
            "px " +
            elTop +
            "px, " +
            elLeft +
            "px " +
            top +
            "px, 0% " +
            top +
            "px, ";
        });
      } else {
        var lightStr =
          "0% " +
          top +
          "px, 100% " +
          top +
          "px, 100% " +
          bottom +
          "px, 0% " +
          bottom +
          "px, 0% " +
          top +
          "px, ";
        //console.log(lightStr);
        lightPath += lightStr;
      }
    });
    lightPath += "0% 0%";
    darkPath += "0% 0%";

    this.elDark.addClass("site-header--dark");
    //if(isInit) this.elLightContainer.css('clip-path', 'polygon('+lightPath+')');
    this.elLightContainer.css("clip-path", "polygon(" + lightPath + ")");
    this.elDarkContainer.css("clip-path", "polygon(" + darkPath + ")");

    this.pathCnt++;
  }

  setLimitsOLD() {
    var __this = this;

    this.darkMatrix = [];
    this.lightMatrix = [];

    var prevTop = 0;
    var prevBottom = 0;

    var stop = this.footer.offset().top + this.scrollPos;
    for (var x = 0; x < this.darkArray.length; x++) {
      var top = this.darkArray[x][0].offset().top;
      var bottom = top + this.darkArray[x][0].outerHeight();

      // test to see if two sections are in the same row
      var testDifference =
        Math.abs(top - prevTop) + Math.abs(bottom - prevBottom);

      if (testDifference > 50) {
        if (!x) {
          this.lightMatrix.push([0, top]);
        } else {
          this.lightMatrix.push([prevBottom, top]);
        }
        this.darkMatrix.push([top, bottom]);
        prevTop = top;
        prevBottom = bottom;
      }
    }
    this.lightMatrix.push([bottom, stop]);
    this.elTop = this.elLight.offset().top - this.scrollPos;

    this.setPaths();
  }

  setPathsOLD() {
    var __this = this;

    var lightPath = "";
    var darkPath = "";
    var bottom = 0;
    this.scrollPos = 0;

    for (var x = 0; x < this.lightMatrix.length; x++) {
      var top = this.lightMatrix[x][0];
      bottom = this.lightMatrix[x][1];

      if (x) lightPath += ", ";
      lightPath +=
        "0% " +
        top +
        "px, 100% " +
        top +
        "px, 100% " +
        bottom +
        "px, 0% " +
        bottom +
        "px";
    }
    lightPath += ", 0% " + bottom + "px, 0% 0px";

    for (var x = 0; x < this.darkMatrix.length; x++) {
      var top = this.darkMatrix[x][0];
      bottom = this.darkMatrix[x][1];

      if (x) darkPath += ", ";
      darkPath +=
        "0% " +
        top +
        "px, 100% " +
        top +
        "px, 100% " +
        bottom +
        "px, 0% " +
        bottom +
        "px";
    }
    darkPath += ", 0% " + bottom + "px, 0% 0px";

    //this.header.css( 'position', 'fixed' );
    //this.header.css( 'width', '100%' );

    this.elDark.addClass("site-header--dark");
    this.elLightContainer.css("clip-path", "polygon(" + lightPath + ")");
    this.elDarkContainer.css("clip-path", "polygon(" + darkPath + ")");
  }
}

/*

class DropDown {
  
  constructor( el ) {
    
    var __this = this;
    
    this.el = el;
    this.rel = this.el.attr( 'data-rel' ).toLowerCase();
    this.relItem = null;
    this.hoverObj = null;
    this.timer = null;
    
    this.headerEl = $( '#site-control' );
    this.navEl = $( '.site-control__inline-links' );

    this.returnRelItem();
    
    if( this.relItem != null ){
      
      this.configRel()
      
    }
    
  }
  
  returnRelItem(){
    
    var __this = this;
    
    this.navEl.find( 'li > a' ).each( function(){
      
      var thisText = $.trim( $( this ).text().toLowerCase() );
      var offset = Math.abs( thisText.length - __this.rel.length );
      
      if( thisText.indexOf( __this.rel ) > -1 && offset < 2 ) {
        
        __this.relItem = $( this );
        
      }
      
    } );
    
  }
  
  configRel(){
    
    var __this = this;
    
    this.el.appendTo( this.headerEl );
    
    this.el.add( this.relItem ).hover( function(){
      
      clearTimeout( __this.timer );
      
      __this.el.addClass( 'hover' );
      
    }, function(){
      
      __this.timer = setTimeout( function(){ __this.el.removeClass( 'hover' ); }, 50 );
      
    } )
    
  }
  
}

*/

class Related {
  constructor() {
    var __this = this;

    this.base = window.location.origin;

    this.tagSelector =
      ".product-list meta[data-related]:not([data-completed]), .product-area meta[data-related]:not([data-completed])";
    this.collectionSelector = ".product-list";
    this.productSelector = ".product-block";
    //this.productFormSelector = '.product-detail__form';
    this.productFormSelector = ".product-area";
    this.relatedProductSelector = ".product-list .product-block";
    this.titleSelector = "span.title";
    this.relatedTag = "data-related";

    this.isChecking = 0;

    this.tag = null;

    $("body").on("test.colors", function () {
      setTimeout(function () {
        __this.runCheck();
      }, 1000);
    });

    this.runCheck();
  }

  runCheck() {
    var __this = this;

    if (this.isChecking) return false;

    var el = $(this.tagSelector);

    if (el.length) {
      this.isChecking = 1;

      $(this.tagSelector)
        .first()
        .each(function () {
          var el = $(this);

          var product = $(this).closest(__this.productSelector);

          __this.tag = el;

          var currTag = el.attr(__this.relatedTag).replace(/\ /g, "-");

          var currUrl = __this.base + "/collections/all/" + currTag;

          $.ajax({
            url: currUrl,
          }).done(function (data) {
            if (el.closest(__this.productSelector).length > 0)
              __this.setupRelatedProducts(data, el, "products");
            else __this.setupRelatedProducts(data, el, "product");
          });
        });
    }
  }

  setupRelatedProducts(data, el, type) {
    var __this = this;

    var intVal = parseInt(el.find(this.relatedProductSelector).length - 1);
    var intLabel = el
      .closest(this.productSelector)
      .find(this.titleSelector)
      .text();

    var tag = __this.tag.attr(this.relatedTag);

    var productMeta = $(
      this.productFormSelector + ' [data-related="' + tag + '"]',
    );

    if (type == "products")
      productMeta = $(
        this.collectionSelector + ' [data-related="' + tag + '"]',
      );

    var products = productMeta.closest(this.productFormSelector);
    if (type == "products")
      products = productMeta.closest(this.productSelector);

    if (intVal) {
      var source = $("#colorTemplate").html();
      var template = Handlebars.compile(source);

      var colors = [];

      $(data)
        .find(this.relatedProductSelector)
        .each(function () {
          var link = $(this).find("a").first().attr("href");
          var swatch = "";
          var color = "";

          if (
            typeof $(this).find("[data-color]").attr("data-color") !=
            "undefined"
          ) {
            color = $(this)
              .find("[data-color]")
              .attr("data-color")
              .replace("color:", "");
          }

          if (
            typeof $(this).find("[data-swatch]").attr("data-swatch") !=
            "undefined"
          ) {
            var int = $(this)
              .find("[data-swatch]")
              .attr("data-swatch")
              .replace("swatch:", "");

            if (int.indexOf("#") > -1) swatch = int;
            if (int.indexOf(".") > -1) swatch = "url(" + int + ")";
          }

          var name =
            color != "" ? color : $(this).find(__this.titleSelector).text();

          colors.push({
            link: link,
            swatch: swatch,
            name: name,
          });
        });

      var context = { colors: colors };

      var html = template(context);
      products.find(".more-colors").html(html);
    }

    productMeta.each(function () {
      $(this).attr("data-completed", "1");
    });

    $("body")[0].offsetHeight;

    this.isChecking = 0;

    __this.runCheck();
  }

  setupRelatedProduct() {
    var __this = this;
  }
}

class StockistStick {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.map = el.find(".map");
    this.timer = null;

    ($(window).on("resize, retrigger load", function () {
      clearTimeout(__this.timer);
      __this.timer = setTimeout(function () {
        __this.setupHeight();
      }, 100);
    }),
      this.setupHeight());

    ($(window).on("scroll", function () {
      __this.runScroll();
    }),
      this.runScroll());
  }
  setupHeight() {
    var __this = this;

    this.windowHeight = $(window).height();
    this.mapHeight = this.map.height();
    this.runScroll();
  }
  runScroll() {
    var __this = this;

    this.scrollPos = $(window).scrollTop();
    this.fixTop = this.windowHeight - this.mapHeight;
    this.elTop = this.el.offset().top;
    this.elPos = this.elTop - this.scrollPos;

    if (this.fixTop < this.elPos) {
      this.map
        .addClass("fixed")
        .css("top", this.fixTop)
        .css("left", this.el.offset().left);
    } else {
      this.map
        .removeClass("fixed")
        .css("top", "0")
        .css("left", "auto")
        .css("right", "auto");
    }
  }
}

class StockistModal {
  constructor(btn) {
    var __this = this;

    this.btn = btn;
    this.modal = $("#stockists-modal-new");
    this.container = this.modal.find(".inner");
    this.close = this.modal.find('[href="/close"]');
    this.btn.on("click", function (e) {
      e.preventDefault();
      __this.container.data("modal", new Stockists(__this.container));
      __this.modal.addClass("reveal");
    });
    this.close.on("click", function (e) {
      e.preventDefault();
      __this.modal.removeClass("reveal").addClass("unreveal");

      setTimeout(function () {
        __this.modal.removeClass("unreveal");
      }, 1000);
    });
  }
}

class SectionScroll {
  constructor(el) {
    var __this = this;
    this.base = el;
    this.distance = 350;

    this.el = this.base.find(this.base.attr("data-section-scroll")).first();
    $(window).on("resize", function () {
      __this.setupLimits();
    });
    $(window).on("scroll", function () {
      __this.runScroll();
    });
    this.setupLimits();
    this.runScroll();
  }
  setupLimits() {
    this.elHeight = this.base.outerHeight();
    this.top = this.base.offset().top;
    this.bottom = this.top + this.elHeight;
  }
  runScroll() {
    var scrollTop = $(window).scrollTop();
    var scrollBottom = scrollTop + $(window).height();

    var pos = 0;

    if (scrollBottom < this.top) pos = -this.distance / 2;
    else if (scrollTop > this.bottom) pos = this.distance / 2;
    else {
      var overflow = scrollBottom - this.top;
      var offset = overflow / (this.elHeight * 2);
      var distance = offset * this.distance - this.distance / 2;
      this.el.css("transform", "translateY(" + distance + "px)");
    }
  }
}

class MobileCheck {
  constructor() {
    var __this = this;
    $(window).resize(function () {
      __this.runCheck();
    });
    this.runCheck();
  }

  runCheck() {
    if ($("#isMobile").is(":visible")) {
      isMobile = 1;
    } else {
      isMobile = 0;
    }
  }
}

class Bundle {
  constructor(el) {
    var __this = this;

    this.el = el;
    this.item = this.el.find(".bundle-item");
    this.btn = el.find(".add-bundle");

    this.setupBundle();
    this.btn.on("click", function (e) {
      e.preventDefault();
      if (!__this.getFirstVariant()) {
      } else {
        __this.btn.attr("disabled", "disabled");
        __this.addBundle();
      }
    });
  }

  setupBundle() {
    var __this = this;

    this.item.each(function () {
      $.data($(this), "bundleItem", new BundleItem($(this), __this));
    });
  }

  testBundle() {
    if (!this.el.find(".product-option:not([data-option])").length) {
      this.el.addClass("can-add");
    }
  }

  addBundle() {
    var __this = this;
    let data = {};
    let variant = this.getFirstVariant();
    variant.attr("data-complete", "complete");
    data["quantity"] = 1;
    data["id"] = variant.attr("data-variant");

    this.updateCart({
      type: "POST",
      url: theme.routes.cartAdd,
      data: data,
      dataType: "json",
    }).then(function () {
      if (!__this.getFirstVariant()) {
        $("body").trigger("added.ajaxProduct");
        $("body").attr("data-cart-active", 1);

        __this.el.find(".variants").each(function () {
          $(this).removeAttr("data-complete");
        });

        this.btn.removeAttr("disabled");
      } else {
        __this.addBundle();
      }
    });
  }
  getFirstVariant() {
    var variants = this.el.find(".variants[data-variant]:not([data-complete])");
    if (variants.length) return variants.first();
    else return 0;
  }
  updateCart(params) {
    return $.ajax(params).then(
      function (cart) {
        return cart;
      }.bind(this),
    );
  }
}

class BundleItem {
  constructor(el, root) {
    var __this = this;

    this.el = el;
    this.block = this.el.closest(".bundle-block");
    this.banner = this.block.find(".bundle-banner");
    this.root = root;
    this.options = this.el.find(".product-option");
    this.span = this.options.find("span");
    this.variant = this.el.find(".variants");
    this.variants = this.el.find(".variants label");

    this.options.each(function () {
      $.data($(this), "bundleOption", new BundleOption($(this), __this));
    });

    /*  
    $(window).on('scroll', function(){
      if(__this.block.is('[data-visible]')){
        var val=100*__this.block.attr('data-prop')
        __this.banner.css('transform', 'translateY('+val+'px)');
      }
    })
    */
  }

  runSpan() {
    var __this = this;

    if (!this.el.find(".product-option:not([data-option])").length) {
      var intStr = "";
      this.el.find(".product-option[data-option]").each(function (index) {
        if (index > 0) intStr += " / ";
        intStr += $.trim($(this).attr("data-option"));
      });

      this.selectVariant(intStr);
    }
  }

  selectVariant(str) {
    var __this = this;

    this.variants.each(function () {
      var compare = $(this).text();

      if (compare == str) {
        __this.variant.attr("data-variant", $(this).attr("value"));
      }
    });

    this.root.testBundle();
  }
}

class BundleOption {
  constructor(el, root) {
    var __this = this;
    this.el = el;
    this.root = root;
    this.span = this.el.find("span");

    if (this.span.length == 1) {
      this.span.first().each(function () {
        if ($(this).is(".avail--true")) {
          $(this).addClass("active");
          __this.el.attr("data-option", $(this).text());
        } else {
          $(this)
            .closest(".options")
            .find("span")
            .each(function () {
              $(this).removeClass("avail--true").addClass("avail--false");
            });
        }
      });
    } else {
      this.span.on("click", function () {
        if ($(this).is(".avail--true")) {
          $(this).addClass("active").siblings().removeClass("active");

          __this.el.attr("data-option", $(this).text());
          __this.root.runSpan($(this));
        }
      });
    }
  }
}

class ElementVisibility {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.wait = 1500;

    this.getBounds();

    $(window).resize(function () {
      __this.getBounds();
    });
    $(window).on("retrigger", function () {
      __this.getBounds();
    });

    $(window).scroll(function () {
      __this.checkVisibility();
    });

    $("body").on("reinit", function () {
      __this.getBounds();
      __this.checkVisibility();
    });

    this.checkVisibility();
  }

  getBounds() {
    var __this = this;
    this.top = this.el.offset().top;
    this.elHeight = this.el.outerHeight();
    this.bottom = this.top + this.elHeight;
  }

  checkVisibility() {
    var intProp = 0;
    //console.log(scrollBottom+'  '+viewPortBottom+'  '+this.bottom)
    if (viewPortBottom < this.top) {
      this.el.attr("data-viewport", "below");
    } else if (viewPortTop > this.bottom) {
      this.el.attr("data-viewport", "above");
    } else {
      this.el.attr("data-viewport", "visible");
    }
    if (scrollBottom < this.top) {
      this.el.removeAttr("data-visible");
    } else if (scrollTop > this.bottom) {
      this.el.removeAttr("data-visible");
      intProp = 2;
    } else {
      this.el.attr("data-init", 1);
      this.el.attr("data-visible", 1);
      intProp = (
        (scrollBottom - this.top) /
        (this.elHeight + $(window).height())
      ).toFixed(3);
      intProp = intProp * 2;
    }
    intProp = intProp - 1;
    this.el.attr("data-prop", intProp);
  }
}

class CarouselInstagram {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.cont = this.el.find("> div");
    this.boxClass = ".carousel-ig--box";
    this.box = this.el.find(this.boxClass);
    this.itemClass = this.el.find(".carousel-ig--item");
    this.attempts = 10;
    this.wait = 1500;
    this.distance = 0.5;
    this.interval = null;
    this.imgClass = ".fs-entry-container";
    this.currPos = 0;
    this.prevScroll = $(window).scrollTop();

    this.direction = this.el.is(".carousel-ig--reversed") ? 1 : 0;

    this.testAvailable();
  }
  testAvailable() {
    var __this = this;
    this.img = this.el.closest(".shopify-section").find(this.imgClass);

    if (this.img.length) {
      this.runSetup();
    } else {
      this.setSetTimeout();
    }
  }

  setSetTimeout() {
    var __this = this;
    setTimeout(function () {
      __this.testAvailable();
    }, this.wait);
  }

  runSetup() {
    var __this = this;

    //this.boxClone=this.box.clone();
    //this.boxClone.appendTo(this.box.parent());
    //this.boxClone[0].offsetHeight;
    this.el.find(this.boxClass).each(function (ind) {
      var intItems = $(this).find(">*");

      intItems.each(function (index) {
        var intItem = $(this);
        var imgEq = index % __this.img.length;
        var intEl = __this.img.eq(imgEq).clone();
        intEl.data("rel", __this.img.eq(imgEq));
        intItem.attr("data-complete", 1);
        intEl.appendTo(intItem.find("> div"));

        $.data(
          intItem,
          "CarouselInstagramImage",
          new CarouselInstagramImage(intItem, intEl),
        );
      });
      /*
      __this.img.each(function(index){
        var intEl=$(this).clone();
        var intItem=intItems.eq(index);
        intItem.attr('data-complete', 1);
        intEl.appendTo(intItem.find('> div'));
        intEl.data('rel', $(this));
        intEl.on('click', function(){
          $(this).data('rel').find('.fs-timeline-entry').trigger('click')
        })
        $.data(intEl, 'CarouselInstagramImage', new CarouselInstagramImage(intEl));
      });
      */
    });

    //this.currPos=Math.round(Math.random()*this.box.find('>*').last().position().left);

    if (this.direction) this.currPos = -1 * this.currPos;

    this.box.find(".carousel-ig--item:not([data-complete])").remove();

    $(window).on("scroll", function () {
      __this.testVisible();
    });

    $(window).resize(function () {
      __this.runPosition();
    });

    this.testVisible();
    this.runPosition();
  }

  testVisible() {
    var __this = this;

    if (__this.el.is("[data-visible]")) {
      // if(__this.interval==null) __this.interval=setInterval( function(){ __this.runSection() }, 36 );
    } else {
      if (__this.interval != null) {
        clearInterval(__this.interval);
        __this.interval = null;
      }
    }
  }

  runPosition() {
    var __this = this;
    var intEl = this.box.find(">*").last();
  }

  runSection() {
    var __this = this;

    var currScroll = $(window).scrollTop();
    var extra = Math.abs(currScroll - this.prevScroll) / 12;
    var newPos = this.currPos - extra - this.distance;

    var overflow = newPos + this.offset;

    newPos = overflow < 0 ? overflow : newPos;
    newPos = newPos.toFixed(3);

    if (this.direction) {
      var intPos = -newPos;
      this.cont.css("transform", "translate(" + intPos + "px, 0)");
    } else {
      this.cont.css("transform", "translate(" + newPos + "px, 0)");
    }

    this.prevScroll = currScroll;
    this.currPos = newPos;
  }
}

class CarouselInstagramImage {
  constructor(box, el) {
    var __this = this;
    this.box = box;
    this.el = el;
    this.rel = this.el.data("rel");
    this.imgClass = ".fs-timeline-entry";
    this.bgImg = null;
    this.wait = 2000;
    this.shortTime = 345 + Math.random() * 200;
    this.longTime = 4400 + Math.random() * 1000;
    this.available = 0;
    this.testAvailable();
  }

  testAvailable() {
    var __this = this;

    var style = this.rel.find(this.imgClass).attr("style");

    if (typeof style == "undefined") {
      this.setSetTimeout();
    } else {
      if (style.indexOf("background-image") > -1) {
        this.runSetup(style);
      } else {
        this.setSetTimeout();
      }
    }
  }

  runSetup(style) {
    var __this = this;
    var intEl = this.el.find(this.imgClass);
    this.available = 1;
    intEl.attr("style", style);
    intEl[0].offsetHeight;
    intEl.removeClass("fs-loading");

    var intElAlt = intEl.parent().clone();
    intElAlt.addClass("entry--alt");
    intElAlt.appendTo(intEl.parent().parent());

    this.post = this.box.find(".fs-entry-container");

    var eq = Math.random() * 100 > 15 ? 0 : 1;
    this.post.eq(eq).addClass("post--active").siblings().addClass("end");
    setTimeout(function () {
      __this.testSwitch();
    }, __this.longTime);

    this.runClick();
  }

  testSwitch() {
    var __this = this;
    if (Math.random() * 100 < 5) {
      this.runSwitch();
    } else {
      setTimeout(function () {
        __this.testSwitch();
      }, __this.longTime);
    }
  }

  runSwitch() {
    var __this = this;

    var inActive = this.box.find(".post--active");
    var active = inActive.siblings();

    active.removeClass("end");
    active.addClass("start");
    active[0].offsetHeight;
    active.removeClass("start");
    active.addClass("post--active");

    inActive.addClass("end");
    inActive.removeClass("post--active");

    setTimeout(function () {
      __this.testSwitch();
    }, __this.longTime);
  }

  runClick() {
    /*
    intItem.on('click', function(){
      $(this).data('rel').find('.fs-timeline-entry').trigger('click')
    })
    */
  }

  setSetTimeout() {
    var __this = this;
    setTimeout(function () {
      __this.testAvailable();
    }, this.wait);
  }
}

class ArticleBanner {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.fix = this.el.find(".fix"); //console.log(this.fix.length+' fixlen');
    this.spacer = this.el.find(".spacer");

    this.initBanner();
    $(window).on("resize", function () {
      __this.initBanner();
    });
    $(window).on("scroll", function () {
      __this.runScroll();
    });
  }
  runScroll() {
    if (typeof this.el.attr("data-prop") == "undefined") return;
    var prop = 1.5 - 1.5 * this.el.attr("data-prop");
    prop = prop > 1 ? 1 : prop;
    this.fix.css("opacity", prop);
  }
  initBanner() {
    var __this = this;
    this.fix.addClass("fixed");
    this.spacer.height(this.fix.outerHeight());
  }
}

class ArticleGallery {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.swiperEl = this.el.find(".swiper");
    this.display = this.el.find(".display");
    this.fix = this.el.find(".fix"); //console.log(this.fix.length+' fixlen');
    this.spacer = this.el.find(".spacer");
    this.next = this.el.find(".next");
    this.prev = this.el.find(".prev");
    this.cnt = this.el.find(".swiper-slide").length;
    this.initGallery();
    setTimeout(function () {
      __this.updateIndex();
    }, 500);
    this.initBanner();
    $(window).on("resize", function () {
      __this.initBanner();
    });
  }
  initBanner() {
    var __this = this;
    this.fix.addClass("fixed");
    this.spacer.height(this.fix.outerHeight());
  }
  initGallery() {
    var __this = this;
    this.swiper = new Swiper(this.swiperEl[0], {
      // Default parameters
      slidesPerView: "auto",
      loop: true,
      // Responsive breakpoints
    });
    this.slide = this.el.find(".swiper-slide");

    this.next.on("click", function () {
      __this.swiper.slideNext();
      __this.updateIndex();
    });
    this.prev.on("click", function () {
      __this.swiper.slidePrev();
      __this.updateIndex();
    });
    this.swiper.on("touchEnd", function () {
      setTimeout(function () {
        __this.updateIndex();
      }, 150);
    });
  }
  updateIndex() {
    var __this = this;
    var rightVal = Math.abs(this.swiper.translate) + $(window).width();
    var active = this.el.find(".swiper-slide-active");
    var activeVal = parseInt(active.attr("data-swiper-slide-index")) + 1;
    var activeStr = activeVal + "";

    active.nextAll().each(function () {
      var elLeft = $(this).position().left;
      var intVal = parseInt($(this).attr("data-swiper-slide-index")) + 1;
      if (elLeft < rightVal) {
        activeStr += ", " + intVal;
      }
    });
    this.display.text("displaying " + activeStr + " | " + this.cnt + " images");
    //console.log('displaying '+activeStr+ ' | '+this.cnt+' images');
  }
}

class MuseH2 {
  constructor(el) {
    var __this = this;

    this.el = el;
    this.base = this.el.closest(".cc-featured-muse");
    this.content = this.base.find(".article-block__content");

    this.flex = this.el.find("> *").first();
    this.block = this.flex.find("> *").first();

    this.blockWidth = 0;
    this.prevScroll = $(window).scrollTop();
    this.currPos = 0;
    this.distance = 0.25;

    this.setupSection();

    $(window).on("scroll", function () {
      __this.runScroll();
    });
    $("body").on("reCalculate", function () {
      setTimeout(function () {
        __this.runScroll();
      }, 150);
    });
    this.runScroll();
  }

  runScroll() {
    if (typeof this.base == "undefined") return;
    var prop = this.base.attr("data-prop");
    var val = prop * 100;
    this.content.css("transform", "translateY(" + val + "px)");
  }

  setupSection() {
    var __this = this;

    this.blockWidth = this.block.first().outerWidth();
    this.interval = setInterval(function () {
      __this.runSection();
    }, 25);
  }

  runSection() {
    var __this = this;

    var currScroll = $(window).scrollTop();
    var extra = Math.abs(currScroll - this.prevScroll) / 12;
    var newPos = this.currPos - extra - this.distance;
    var overflow = newPos + this.block.first().outerWidth();
    newPos = overflow < 0 ? overflow : newPos;
    this.flex.css("transform", "translate(" + newPos + "px, 0)");

    this.prevScroll = currScroll;
    this.currPos = newPos;
  }
}

class MuseBlock {
  // sets min heights

  constructor(el) {
    var __this = this;
    this.el = el;
    this.block = this.el.find(".muse-banner .grid > div:visible").last();

    $(window).on("resize", function () {
      __this.setHeight();
    });
    this.el.find("img").each(function () {
      if ($(this)[0].complete) {
        __this.setLoadClass($(this));
      } else {
        $(this).on("load", function () {
          __this.setLoadClass($(this));
          __this.setHeight();
        });
      }
    });
    this.setHeight();
  }
  setLoadClass(el) {
    $("body").trigger("reinit");
    el.closest(".muse--image").addClass("loaded");
  }
  setHeight() {
    var __this = this;
    if (!this.block.length) return;
    var elHeight = this.block.position().top + this.block.outerHeight();
    this.el.css("min-height", elHeight + "px");
    $("body").trigger("reCalculate");
  }
}

class MuseProducts {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.swiperEl = this.el.find(".swiper");
    this.next = this.el.find('[href="#next"]');
    this.prev = this.el.find('[href="#prev"]');
    this.display = this.el.find(".display");
    this.slidesInView = 2;
    this.initGallery();
  }

  initGallery() {
    var __this = this;
    this.swiper = new Swiper(this.swiperEl[0], {
      // Default parameters
      slidesPerView: 2,
      loop: true,
      // Responsive breakpoints
      on: {
        init: function init() {
          lazySizes.autoSizer.checkElems();

          var firstIndex = this.activeIndex + 1;
          var lastIndex = firstIndex + __this.slidesInView - 1;
          var text =
            firstIndex +
            " – " +
            lastIndex +
            " of " +
            __this.el.find(".swiper-slide").length;
          __this.display.text(text);
        },
        activeIndexChange: function () {
          var firstIndex = this.activeIndex;
          var lastIndex = firstIndex + __this.slidesInView - 1;
          var text =
            firstIndex +
            " – " +
            lastIndex +
            " of " +
            __this.el.find(".swiper-slide").length;
          __this.display.text(text);
        },
      },
    });

    this.slide = this.el.find(".swiper-slide");

    this.next.on("click", function (e) {
      e.preventDefault();
      __this.swiper.slideNext();
      //__this.updateIndex();
    });

    this.prev.on("click", function () {
      __this.swiper.slidePrev();
      //__this.updateIndex();
    });
    /*
      this.swiper.on('touchEnd', function(){
        setTimeout(function(){ __this.updateIndex(); }, 150);
      })
      */
  }
  updateIndex() {
    var __this = this;
    var rightVal = Math.abs(this.swiper.translate) + $(window).width();
    var active = this.el.find(".swiper-slide-active");
    var activeVal = parseInt(active.attr("data-swiper-slide-index")) + 1;
    var activeStr = activeVal + "";

    active.nextAll().each(function () {
      var elLeft = $(this).position().left;
      var intVal = parseInt($(this).attr("data-swiper-slide-index")) + 1;
      if (elLeft < rightVal) {
        activeStr += ", " + intVal;
      }
    });
    this.display.text("displaying " + activeStr + " | " + this.cnt + " images");
    //console.log('displaying '+activeStr+ ' | '+this.cnt+' images');
  }
}

class MuseFeatured {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.block = this.el.find(".article-block--meta");
    this.slide = this.el.find(".muse--image.muse--image__flex");
    $(window).on("resize", function () {
      __this.setMin();
    });
    this.setMin();
    this.setClass();
  }
  setMin() {
    var __this = this;
    var height =
      this.block.position().top +
      this.block.outerHeight() +
      this.block.parent().position().top;
    this.el.height(height);
    this.slide.height(height);
  }
  setClass() {
    var __this = this;
    this.slide.each(function () {
      var el = $(this).find("img").first();
      if (el[0].complete) $(this).addClass("loaded");
      else {
        el.on("load", function () {
          $(this).addClass("loaded");
        });
      }
    });
  }
}

class SectionStack {
  constructor() {
    var __this = this;
    this.shopSection = $("#page-content > div");
    this.sectionClass = ".section-stack";
    this.columnClass = ".section-stack-column";
    this.heightElClass = '[class*="section-id-template"]';
    this.overlayClass = ".text-overlay";
    this.smallClass = "[aria-small]";
    this.spacerClass = ".spacer";
    this.stackEl = null;
    this.isInit = 0;
    this.runStack();
  }
  runStack() {
    var __this = this;
    this.shopSection.each(function () {
      if ($(this).is(__this.sectionClass)) {
        __this.runColumn($(this));
        __this.setColumnHeight($(this));
        if ($(this).find(".terminate--true").length) __this.stackEl = null;
        else __this.stackEl = $(this);
      } else {
        __this.carrySpace($(this));
        __this.stackEl = null;
      }
    });
  }
  carrySpace(el) {
    if (el.find(".section-spacer").length) {
      var space = this.returnTallColumn(el);
      el.find(".section-spacer").css("height", "calc(" + space + " * 100vw)");
    }
  }
  runColumn(el) {
    var __this = this;
    var columns = el.find(this.columnClass);
    this.setSmallColumn(columns);
    columns.each(function () {
      var space = Number(__this.returnColumn($(this)));
      $(this).attr("aria-space", space);
      $(this)
        .find(__this.spacerClass)
        .css("height", "calc(" + space + " * 100vw)");
    });
  }
  setColumnHeight(el) {
    var __this = this;
    var small = this.returnSmallColumn(el);
    //console.log(small.length+'sm len');
    var smallTotal = 0;

    if (small != null) {
      smallTotal = Number(small.attr("aria-aspect-total"));

      el.attr("aria-small-aspect-total", smallTotal);
      var columns = el.find(this.columnClass);
      columns.each(function () {
        var total = Number($(this).attr("aria-aspect-total"));
        var diffTotal = (total - smallTotal) / columns.length;
        var invTotal = -100 * diffTotal;
        if (!el.find(".terminate--true").length) {
          $(this)
            .attr("aria-over", diffTotal)
            .css("margin-bottom", invTotal + "vw");
        }
      });
    }
  }

  setSmallColumn(el) {
    var intSmall = 9999;
    var smallEl = null;
    el.each(function () {
      var small = $(this).attr("aria-aspect");
      if (small < intSmall) {
        intSmall = small;
        smallEl = $(this);
      }
    });
    smallEl.attr("aria-small", 1);
  }
  returnSmallColumn(el) {
    var small = 9999;
    var smallEl = null;
    var columns = el.find(this.columnClass);
    columns.each(function () {
      var el = $(this);
      var height = 0;
      var intEl = el.find("> *");
      intEl.each(function () {
        height += $(this).height();
      });
      var width = $(this).width();
      var aspectVal = height / width;
      $(this).attr("aria-aspect-total", aspectVal);
      if (height < small) {
        small = height;
        smallEl = $(this);
        $(this).attr("aria-small", 1).siblings().removeAttr("aria-small");
      }
    });
    return smallEl;
  }
  XXXreturnSmallColumn(el) {
    var small = 9999;
    var columns = el.find(this.columnClass);
    columns.each(function () {
      var el = $(this);
      var aspectVal = el.attr("aria-aspect");
      if (aspectVal == "") {
        aspectVal = el.height() / el.width();
        el.attr("aria-aspect", aspectVal);
      }
      var spaceVal = el.attr("aria-space");
      var totalVal = Number(aspectVal) + Number(spaceVal);
      if (totalVal < small) {
        el.attr("aria-small", 1).siblings().removeAttr("aria-small");
      }
    });

    // recalculate section height
    var small = el.find("[aria-small]");
    var totalVal =
      Number(small.attr("aria-aspect")) / columns.length +
      Number(small.attr("aria-space"));
    columns.each(function () {
      var el = $(this);
      var total =
        Number(el.attr("aria-aspect")) / columns.length +
        Number(el.attr("aria-space"));
      var diffVal = total - totalVal;
      el.attr("aria-over", diffVal);
    });

    return el.find("[aria-small]");
  }
  returnTallColumn() {
    if (this.stackEl == null) return 0;
    else {
      var large = 0;
      this.stackEl.find(this.columnClass).each(function () {
        var over = Number($(this).attr("aria-aspect-total"));
        if (over > large) large = over;
      });
      return large;
    }
  }
  returnColumn(el) {
    if (this.stackEl == null) {
      return 0;
    } else {
      var index = el.index();
      var stackColumn = this.stackEl.find(this.columnClass);
      var testEl = null;
      //var small=this.stackEl.find(this.smallClass).first();
      //var smallSpace=small.attr('aria-space');
      if (stackColumn.eq(index).length) testEl = stackColumn.eq(index);
      else testEl = stackColumn.last();
      return Number(testEl.attr("aria-over"));
    }
  }
}

class SplitScroll {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.frame = this.el.find(".split-columns");
    this.block = this.el.find(".split-base");
    this.limits = [];

    $(window).on("resize", function () {
      __this.setLimits();
      __this.calculateLimits();
    });
    $(window).on("scroll", function () {
      __this.calculateLimits();
    });
    this.setLimits();
    this.calculateLimits();
  }
  setLimits() {
    this.limits[0] = this.frame.offset().top;
    this.limits[1] =
      this.frame.offset().top +
      this.frame.outerHeight() -
      this.block.outerHeight();
  }
  calculateLimits() {
    var headerOffset = getComputedStyle(
      document.documentElement,
    ).getPropertyValue("--header-height");
    if (scrollTop < this.limits[0]) {
      this.block
        .removeClass("split-test--fixed")
        .removeClass("split-test--to-bottom");
    } else if (scrollTop > this.limits[1]) {
      this.block
        .removeClass("split-test--fixed")
        .addClass("split-test--to-bottom");
    } else {
      this.block
        .addClass("split-test--fixed")
        .addClass("split-test--to-bottom");
    }
  }
}

class StickyElement {
  constructor(el, frame, block, position) {
    var __this = this;
    this.el = el;
    this.position = position;
    this.frame = this.el.find(frame);
    this.block = this.el.find(block);
    this.limits = [];

    if (this.frame.length) this.runSetup();
  }

  runSetup() {
    var __this = this;

    $(window).on("resize", function () {
      __this.setLimits();
      __this.calculateLimits();
    });
    $(window).on("scroll", function () {
      __this.calculateLimits();
    });
    this.setLimits();
    this.calculateLimits();
  }

  setLimits() {
    this.limits[0] = this.frame.offset().top + this.block.outerHeight();
    this.limits[1] = this.frame.offset().top + this.frame.outerHeight();
  }

  calculateLimits() {
    var headerOffset = getComputedStyle(
      document.documentElement,
    ).getPropertyValue("--header-height");
    var position = this.position == "bottom" ? scrollBottom : scrollTop;

    if (position < this.limits[0]) {
      this.block.removeClass("fixed").removeClass("to-final");
    } else if (position > this.limits[1]) {
      this.block.removeClass("fixed").addClass("to-final");
    } else {
      this.block.addClass("fixed").removeClass("to-final");
    }
  }
}

class ReturnString {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.strong = el.find("strong");
    this.stringTxt = el.text();
    this.stringArray = [];
    this.el.html("");
    if (this.strong.length) this.createSplit();
    else {
      this.wrapString();
    }
  }
  wrapString() {
    this.el.html("<span>" + this.stringTxt + "</span>");
  }
  createSplit() {
    var __this = this;
    this.strong.each(function (index) {
      var strongTxt = $(this).text();
      if (!__this.stringArray.length) {
        var intArray = __this.stringTxt.split(strongTxt);
        __this.reconstituteString(strongTxt, intArray);
      } else {
        el.find("> span").each(function () {
          item = $(this);
          itemTxt = item.text();
          if (itemTxt.indexOf(strongTxt) > -1) {
            var intArray = item.split(strongTxt);
            for (var x = 0; x < intArray.length; x++) {
              if (x > 0)
                $("<strong>" + strongTxt + "</strong>").insertBefore(item);
              $("<span>" + intArray[x] + "</span>").insertBefore(item);
            }
            item.remove();
          }
        });
      }
    });
  }
  reconstituteString(strongTxt, intArray) {
    var __this = this;
    var newArray = [];
    for (var x = 0; x < intArray.length; x++) {
      if (x > 0) this.el.append("<strong>" + strongTxt + "</strong>");
      if (intArray[x] != "") this.el.append("<span>" + intArray[x] + "</span>");
    }
  }
}

class ProductFloat {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.hover = this.el.find("> span");
    this.cursor = this.el.find("b");
    this.currX = 0;
    this.currY = 0;
    this.timer = null;
    this.interval = 25;
    this.minVal = 0.0125;
    this.runSetup();
  }

  runSetup() {
    var __this = this;
    this.hover.hover(
      function () {},
      function () {
        __this.setFinal();
      },
    );
    this.hover.on("mousemove", function (e) {
      __this.setStart(e);
    });
  }

  setStart(e) {
    var __this = this;
    var xPos = e.pageX;
    var yPos = e.pageY;

    this.finalX = (xPos - this.el.offset().left) / 1.2;
    this.finalY = (yPos - this.el.offset().top) / 1.2;

    clearTimeout(__this.timer);
    this.runLerper();
  }

  setFinal() {
    this.finalX = 0;
    this.finalY = 0;
    this.runLerper();
  }

  runLerper() {
    var __this = this;
    var diff = this.lerper();
    if (diff > this.minVal)
      this.timer = setTimeout(function () {
        __this.runLerper();
      }, this.interval);
  }

  lerper() {
    var intX = this.currX + (this.finalX - this.currX) * 0.05;
    var intY = this.currY + (this.finalY - this.currY) * 0.05;

    this.cursor.css("top", intY).css("left", intX);

    this.prevX = this.currX;
    this.prevY = this.currY;

    this.currX = intX;
    this.currY = intY;

    var diff =
      Math.abs(this.prevX - this.currX) + Math.abs(this.prevY - this.currY);

    return diff;
  }
}

class CollectionImages {
  constructor() {
    var __this = this;
    /*
    $('body').on('filterComplete', function(){
      __this.setupImages();
    })
    */
    $("body").on("filterComplete", function () {
      __this.setupImages();
      __this.updateAllImages();
    });
    this.findColor();
    this.setupImages();
    this.updateAllImages();
  }
  getColorEl() {
    return $(
      '#FacetsForm [data-type="color"], #FacetsForm [data-type="colour"], #FacetsForm [data-type="material"]',
    ).first();
  }
  findColor() {}
  updateAllImages() {
    var __this = this;
    //var color=$('body').data('data-color');

    var el = this.getColorEl().find("input:checked");
    if (el.length) {
      this.color = el.attr("value");
    } else {
      this.color = null;
      return;
    }

    /*
    if(color!=null) {
      
      if(color==this.color) return;
      else 
      
      
      this.color=color      
    }else {
      //return
    }
    */

    var color = this.color
      .toLowerCase()
      .replace(/[_-\s]/g, "")
      .replace("18k", "")
      .replace("9k", "")
      .replace("14k", "");

    if (color != "") {
      $(".product-block").each(function () {
        //console.log($(this).data('collectionImage')+'  obj???');
        if (typeof $(this).data("collectionImage") != "undefined") {
          //console.log('updating color?');
          $(this).data("collectionImage").updateImages(color);
        }
      });
    }
  }
  setupImages() {
    var __this = this;
    $(".product-block").each(function () {
      if (typeof $(this).data("collectionImage") == "undefined") {
        $(this).data("collectionImage", new CollectionImage($(this)));
      } else {
      }
    });
  }
}

class CollectionImage {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.option = ".product-block--option";
    this.variant = ".product-block--option > span";
    this.el.data(
      "relatedImage",
      new RelatedImages(
        this.el,
        this.option,
        this.variant,
        ".image--container span",
      ),
    );
    this.setupImages();
    this.setupHover();
  }
  setupHover() {
    var __this = this;
    if (typeof $(this.variant).attr("data-variant") == "undefined") return;
    this.el.find(this.variant).on("mouseover", function () {
      var color = $(this).attr("data-variant");
      var imgArray = __this.el.data("relatedImage").returnImages([color]);
      var existing = __this.el.find('[data-related="' + color + '"]');
      if (existing.length) {
        existing.removeClass("inactive");
        return;
      }
      if (imgArray[0].length) {
        var src = $(imgArray[0][1]).attr("data-src-persist");
        var el = $(
          '<div class="image__third image__third__' +
            color +
            '" src="' +
            src +
            '" data-related="' +
            color +
            '"><img data-src="' +
            src +
            '" src="' +
            src +
            '"></div>',
        );
        el.appendTo(__this.el.find(".image--switcher"));
      }
    });
    this.el.find(this.variant).on("mouseout", function () {
      var color = $(this).attr("data-variant");
      var existing = __this.el.find('[data-related="' + color + '"]');
      if (existing.length) {
        existing.addClass("inactive");
      }
    });
  }
  updateImages(color) {
    var __this = this;
    var intArray = [color];
    var imgArray = __this.el.data("relatedImage").returnImages(intArray);
    __this.changeImages(imgArray);
  }
  setupImages() {
    var __this = this;
    this.el.find(this.variant).on("click, update", function (e) {
      e.preventDefault();
      var intArray = [];
      var value = $(this)
        .attr("data-value")
        .toLowerCase()
        .replace(/[_-\s]/g, "")
        .replace("18k", "")
        .replace("9k", "")
        .replace("14k", "");
      intArray.push(value);
      var imgArray = __this.el.data("relatedImage").returnImages(intArray);
      __this.changeImages(imgArray);
    });
  }
  changeImages(array) {
    var __this = this;
    if (typeof array[0] == "undefined") return;

    this.el.attr("data-img-alt", 1);
    this.el.find(".image--switcher").html("");

    for (var x = 0; x < 2; x++) {
      var src = $(array[0][x]).attr("data-src-persist");
      var img = this.el.find(".image__first img");
      if (x == 1) img = this.el.find(".image__second img");

      if (img.length) {
        img.attr("src", src);
        var el = $(
          '<div class="image__third image__third__' +
            x +
            '" src="' +
            src +
            '"><img data-src="' +
            src +
            '" src="' +
            src +
            '"></div>',
        );
        el.appendTo(this.el.find(".image--switcher"));
      }
    }
  }
}

class RelatedImages {
  constructor(el, option, variant, img) {
    var __this = this;
    this.el = el;
    this.option = option;
    this.variant = variant;
    this.img = img;
    this.setupRelated();
  }
  reInitialise() {
    var __this = this;
    this.setupRelated();
  }
  setupRelated() {
    var __this = this;
    this.relatedObject = [];

    this.el.find(this.option).each(function () {
      var hasImg = 0;
      var sel = $(this);

      var option = $(this)
        .parent()
        .find("label")
        .first()
        .text()
        .toLowerCase()
        .replace(/[_-\s]/g, "");

      __this.el.find(__this.variant).each(function () {
        var value = $(this).attr("value");
        var variant = value
          .toLowerCase()
          .replace(/[_-\s]/g, "")
          .replace("18k", "")
          .replace("9k", "")
          .replace("14k", "");

        var intObject = __this.checkImage(variant, option);

        if (intObject.length) {
          sel.attr("has-image", 1);
          __this.relatedObject[variant] = intObject;
        }
      });
    });
    /*
    if(this.relatedObject.length){
      console.log('rel');
      console.log(this.relatedObject);
    }
    */
  }

  checkImage(variant, option) {
    var __this = this;
    var imgObject = [];
    var option = option.replace(/[_-\s]/g, "");
    //var compareStr=opt.toLowerCase().replace(/[_-\s]/g,"").replace('18k', '').replace('9k', '');

    this.el.find(this.img).each(function () {
      var src = $(this).attr("data-src-persist");
      var vidSrc = $(this).find("source").attr("src");
      var testStr = "";
      if (typeof src != "undefined")
        var testStr = src
          .split(",")[0]
          .toLowerCase()
          .replace(/[_-\s]/g, "");
      if (typeof vidSrc != "undefined")
        var testStr = vidSrc
          .split(",")[0]
          .toLowerCase()
          .replace(/[_-\s]/g, "");
      if (typeof $(this).attr("alt") != "undefined")
        testStr += $(this)
          .attr("alt")
          .toLowerCase()
          .replace(/[_-\s]/g, "");
      if (typeof $(this).attr("aria-label") != "undefined")
        testStr += $(this)
          .attr("aria-label")
          .toLowerCase()
          .replace(/[_-\s]/g, "");
      if (testStr.indexOf(variant) > -1) {
        imgObject.push($(this));
      }
    });
    return imgObject;
  }

  returnImages(array) {
    var variantArray = [];
    var imgArray = [];
    for (var x = 0; x < array.length; x++) {
      var relArray = this.relatedObject[array[x]];
      if (typeof relArray != "undefined") variantArray.push(relArray);
    }

    if (variantArray.length == 1) imgArray = variantArray;
    if (variantArray.length > 1) {
      var testArray = variantArray[0];
      for (var x = 0; x < testArray.length; x++) {
        var testVal = testArray[x][0];
        var inArray = 1;
        for (var y = 1; y < variantArray.length; y++) {
          var hasImage = 0;
          for (var z = 0; z < variantArray[y].length; z++) {
            if (testVal === variantArray[y][z][0]) {
              hasImage = 1;
            }
          }
          if (!hasImage) inArray = 0;
        }
        if (inArray) imgArray.push(testVal);
      }
    }
    return imgArray;
  }
}

class ProductImages {
  constructor() {
    var __this = this;

    this.container = $(".section-product-template");
    this.section = $('[data-section-type="product-template"]');
    this.selectorContainer = this.section.find(".option-selectors");
    this.gallery = this.section.find(".theme-viewport");

    this.activeArr = [];
    this.imageArray = [];

    this.setupImages();
  }

  setupImages() {
    var __this = this;
    if (typeof this.section.data("related-images") == "undefined") {
      this.section.each(function () {
        $(this).data(
          "related-images",
          new RelatedImages(
            $(this),
            ".option-selectors select",
            ".option-selectors option",
            ".theme-viewport img, .theme-viewport video",
          ),
        );
      });
    } else {
      this.section.data("related-images").reInitialise();
    }
    this.selectorContainer.find("select").on("change", function () {
      __this.runImages();
    });
    this.runImages();
  }

  runImages() {
    var __this = this;
    var intArray = [];

    this.setMinImageHeight();

    __this.selectorContainer.find("select").each(function () {
      var value = $(this)
        .val()
        .toLowerCase()
        .replace(/[_-\s]/g, "")
        .replace("18k", "")
        .replace("9k", "")
        .replace("14k", "");
      intArray.push(value);
    });
    var imgArray = __this.section.data("related-images").returnImages(intArray);
    if (imgArray.length) imgArray = imgArray[0];
    if (imgArray.length >= 1) {
      $(".theme-viewport .theme-img").hide();
      //$('.theme-viewport .theme-img').css('opacity', '.5');
      imgArray.forEach((img) => {
        $(img).closest(".theme-img").show();
        //$(img).closest('.theme-img').css('opacity', '1');
      });
    } else {
      $(".theme-viewport .theme-img").show();
    }
  }

  setMinImageHeight() {
    var __this = this;
    var minHeight = $(".product-area > .product-form > div").outerHeight();
    $(".product-area__media").css("min-height", minHeight);
  }
}

class ShapeStyle {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.container = $(".section-product-template");
    this.section = $('[data-section-type="product-template"]');
    this.selectorContainer = this.section.find(".option-selectors");
    this.btnContainer = this.section.find('[data-block-type="buy_buttons"]');
    this.gallery = this.section.find(".theme-viewport");
    this.galleries = {};
    this.handles = this.el.attr("data-rel");
    this.handleArr = this.handles.split(",");
    this.preferredPotential = "shape";

    this.activeArr = [];
    this.imageArray = [];

    this.diamondSelector =
      '[data-option-name*="Diamond"] .option--header label';
    this.existingDiamond = $(this.diamondSelector).parent().html();
    console.log(this.existingDiamond);

    this.getOptions();
    this.setupImages();
    this.setupStone();

    this.el.find("a").on("click", function (e) {
      e.preventDefault();
      if (!$(this).is(".active")) {
        __this.runShapeStyle($(this));
      }
    });
  }

  setupStone() {
    var __this = this;
    this.selector = $('[data-option-name*="Diamond"]');
    this.select = this.selector.find("select");
    this.btnBlock = $(".product-area .product-stone-btn");
    var height = this.btnBlock.find("> *").outerHeight();
    document.documentElement.style.setProperty(
      "--product-stone-btn-height",
      height + "px",
    );
    this.select.each(function () {
      $(this).on("change", function () {
        //__this.runStone();
      });
    });
    /*
    $('body').trigger('initStoneBtn');
    this.runStone();
    */
  }
  runStone() {
    var sel = $('.product-area [data-option-name*="Diamond"] select');
    if (sel.length > 0) {
      var val = sel.val().toLowerCase();
      if (val == "custom" || val == "other") {
        this.btnBlock.addClass("active");
      } else {
        this.btnBlock.removeClass("active");
      }
    }
  }

  setupImages() {
    var __this = this;
    if (typeof this.section.data("related-images") == "undefined") {
      this.section.each(function () {
        $(this).data(
          "related-images",
          new RelatedImages(
            $(this),
            ".option-selectors select",
            ".option-selectors option",
            ".theme-viewport img, .theme-viewport video",
          ),
        );
      });
    } else {
      this.section.data("related-images").reInitialise();
    }
    this.selectorContainer.find("select").on("change", function () {
      __this.runImages();
    });
    this.runImages();
  }

  runImages() {
    var __this = this;
    var intArray = [];

    this.setMinImageHeight();

    __this.selectorContainer.find("select").each(function () {
      var value = $(this)
        .val()
        .toLowerCase()
        .replace(/[_-\s]/g, "")
        .replace("18k", "")
        .replace("9k", "")
        .replace("14k", "");
      intArray.push(value);
    });
    var imgArray = __this.section.data("related-images").returnImages(intArray);
    if (imgArray.length) imgArray = imgArray[0];
    if (imgArray.length >= 1) {
      $(".theme-viewport .theme-img").hide();
      //$('.theme-viewport .theme-img').css('opacity', '.5');
      imgArray.forEach((img) => {
        $(img).closest(".theme-img").show();
        //$(img).closest('.theme-img').css('opacity', '1');
      });
    } else {
      $(".theme-viewport .theme-img").show();
    }
  }

  setMinImageHeight() {
    var __this = this;
    var minHeight = $(".product-area > .product-form > div").outerHeight();
    $(".product-area__media").css("min-height", minHeight);
  }

  getOptions() {
    var __this = this;
    this.activeArr = [];

    this.selectorContainer.find("select").each(function () {
      __this.activeArr.push($(this).val());
    });
  }

  runShapeStyle(el) {
    var __this = this;

    el.addClass("active").parent().siblings().find("a").removeClass("active");
    el.closest('[class*="selector-wrapper"]')
      .find(".option--value")
      .text(el.attr("data-value"));
    var potentials = [];
    var wasFound = 0;
    this.handleArr.forEach(function (handle, index) {
      var isBoth = 1;
      __this.el.find("a.active").each(function () {
        var txt = $(this).attr("data-value");
        if (handle.indexOf(txt) == -1) isBoth = 0;
        else {
          if (
            $(this).closest("[data-option-name]").attr("data-option-name") ==
            __this.preferredPotential
          )
            potentials.push(handle);
        }
      });
      if (isBoth) {
        var url = "/products/" + handle;
        wasFound = 1;
        __this.runClick(handle);
      }
    });
    if (!wasFound && potentials.length) {
      this.runClick(potentials[0]);
      this.reInitButtons(potentials[0]);
    }
  }
  reInitButtons(handle) {
    this.el.find("[data-option-name]").each(function () {
      $(this)
        .find("a")
        .each(function () {
          var val = $(this).attr("data-value");
          if (handle.indexOf(val) == -1) $(this).removeClass("active");
          else $(this).addClass("active");
        });
    });
  }
  runClick(handle) {
    var __this = this;

    this.getOptions();
    this.selector.off();

    var el = $('.item[data-handle="' + handle + '"]');

    var selectors = el.find(".selectors");
    $(selectors)
      .find(".selector-wrapper")
      .each(function () {
        $(this).addClass("no-transition");
      });
    var selectorsHTML = selectors.html();

    var title = el.find(".title").first().text();
    var btn = el.find(".form").html();
    var id = el.attr("data-id");

    //turn off animation

    selectors[0].offsetHeight;

    if (el.find("script").length) el.find("script").appendTo(this.container);

    //unload

    theme.ProductTemplateSection.onSectionUnload(this.section, true);

    this.section.attr("data-product-id", id);
    this.section.data("product-id", id);

    $(".product-area__details__title").text(title);

    this.selectorContainer.html(selectorsHTML);
    this.selectorContainer.find("select").each(function () {
      $(this).clickyBoxes();
    });
    this.btnContainer.html(btn);

    var intURL = "/products/" + handle;
    history.pushState("", "", intURL);

    //reload
    theme.ProductTemplateSection.onSectionLoad(this.section, true);
    theme.initComponents(this.section);
    theme.initShopifyPaymentButtons(this.section);

    for (var x = 0; x < this.activeArr.length; x++) {
      var el = this.selectorContainer.find(
        'a[data-value-lower="' + this.activeArr[x].toLowerCase() + '"]',
      );
      if (el.length) el.trigger("click");
    }

    // re-add animation
    this.selectorContainer.find(".no-transition").each(function () {
      $(this).removeClass("no-transition");
    });

    this.setupStone();
    this.setupGallery(intURL);
    //theme.applyAjaxToProductForm(this.section);
  }

  setupGallery(url) {
    var __this = this;

    /*$.ajax({ url: url }).done(function(data){
      var el=$(data).find('.theme-viewport');
      __this.gallery.html(el.html());
      __this.setupImages();
      __this.runImages();
    })*/
    /*
    $.ajax({ url: url }).done(function(data){
      var el=$(data).find('.theme-viewport .theme-img');
      console.log(el.length+'len');
      //__this.gallery.html(el.html());
      
      __this.gallery.find('.theme-img').remove();
      el.each(function(){
        $(this).appendTo(__this.gallery.find('.theme-images'));
      })
      */

    $.ajax({ url: url }).done(function (data) {
      $(".product-area__media .theme-gallery")
        .addClass("fade")
        .delay(675)
        .queue(function () {
          $(".product-area__media .theme-gallery").remove();
          var el = $(data).find(".theme-gallery");
          var sectionUniqueId = new Date().getTime();
          el.addClass("fade");
          el.attr("gallery", sectionUniqueId);
          el.appendTo(".product-area__media");
          if (el.length > 0) {
            __this.galleries[sectionUniqueId] = new theme.ProductMediaGallery(
              el,
              $(".theme-gallery-thumb", el),
              0,
              0,
              sectionUniqueId,
            );
          }

          __this.setupImages();
          __this.runImages();
          el.removeClass("fade");

          $(window).trigger("resize");
        });
    });
  }
}
class ShapeStyleBak {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.container = $(".section-product-template");
    this.section = $('[data-section-type="product-template"]');
    this.selectorContainer = this.section.find(".option-selectors");
    this.btnContainer = this.section.find('[data-block-type="buy_buttons"]');
    this.gallery = this.section.find(".theme-viewport");
    this.handles = this.el.attr("data-rel");
    this.handleArr = this.handles.split(",");

    this.activeArr = [];
    this.imageArray = [];

    this.getOptions();
    this.setupImages();
    this.setupStone();

    this.el.find("a").on("click", function (e) {
      e.preventDefault();
      if (!$(this).is(".active")) {
        __this.runShapeStyle($(this));
      }
    });
  }

  setupStone() {
    var __this = this;
    this.selector = $('[data-option-name*="Diamond"]');
    this.select = this.selector.find("select");
    this.btnBlock = $(".product-area .product-stone-btn");
    var height = this.btnBlock.find("> *").outerHeight();
    document.documentElement.style.setProperty(
      "--product-stone-btn-height",
      height + "px",
    );
    this.select.each(function () {
      $(this).on("change", function () {
        __this.runStone();
      });
    });
    $("body").trigger("initStoneBtn");
    this.runStone();
  }
  runStone() {
    var sel = $('.product-area [data-option-name*="Diamond"] select');
    var val = sel.val().toLowerCase();
    if (val == "custom" || val == "other") {
      this.btnBlock.addClass("active");
    } else {
      this.btnBlock.removeClass("active");
    }
  }

  setupImages() {
    var __this = this;
    if (typeof this.section.data("related-images") == "undefined") {
      this.section.each(function () {
        $(this).data(
          "related-images",
          new RelatedImages(
            $(this),
            ".option-selectors select",
            ".option-selectors option",
            ".theme-viewport img, .theme-viewport video",
          ),
        );
      });
    } else {
      this.section.data("related-images").reInitialise();
    }
    this.selectorContainer.find("select").on("change", function () {
      __this.runImages();
    });
    this.runImages();
  }

  runImages() {
    var __this = this;
    var intArray = [];
    __this.selectorContainer.find("select").each(function () {
      var value = $(this)
        .val()
        .toLowerCase()
        .replace(/[_-\s]/g, "")
        .replace("18k", "")
        .replace("9k", "")
        .replace("14k", "");
      intArray.push(value);
    });
    var imgArray = __this.section.data("related-images").returnImages(intArray);
    console.log(imgArray.length + " array length");

    if (imgArray.length > 1) {
      $(".theme-viewport .theme-img").hide();
      //$('.theme-viewport .theme-img').css('opacity', '.5');
      imgArray.forEach((img) => {
        $(img).closest(".theme-img").show();
        //$(img).closest('.theme-img').css('opacity', '1');
      });
    } else {
      $(".theme-viewport .theme-img").show();
    }
  }

  /*
  setupImagesOld(){
    var __this=this;
    
    this.selectorContainer.find('select').each(function(){
      var hasImg=0;
      var sel=$(this);
      var label=$(this).parent().find('label').first().text().toLowerCase().replace(/[_-\s]/g,"");
      sel.attr('data-type', label)
      
      $(this).find('option').each(function(){
        var val=$(this).attr('value');
        if(__this.checkImage(val, label)) sel.attr('has-image', 1);
      })  
    })
  }
  
  checkImage(opt, label){
    var __this=this;
    var hasImg=0;
    var label=label.replace(/[_-\s]/g,"");
    var compareStr=opt.toLowerCase().replace(/[_-\s]/g,"").replace('18k', '').replace('9k', '');
    
    this.section.find('.theme-viewport img').each(function(){
      var src=$(this).attr('data-src-persist');
      if(typeof src!='undefined'){
        var testStr=src.split(',')[0].toLowerCase().replace(/[_-\s]/g,"");
        testStr+=$(this).attr('alt').toLowerCase().replace(/[_-\s]/g,"");
        //console.log(testStr);
        if(testStr.indexOf(compareStr)>-1){ 
          console.log('found');
          hasImg=1;
          $(this).attr('data-'+label, compareStr);
        }
      }
    })
    return hasImg;
  }
  */

  getOptions() {
    var __this = this;
    this.activeArr = [];

    this.selectorContainer.find("select").each(function () {
      __this.activeArr.push($(this).val());
    });
  }

  runShapeStyle(el) {
    var __this = this;
    el.addClass("active").parent().siblings().find("a").removeClass("active");
    this.handleArr.forEach(function (handle, index) {
      var isBoth = 1;
      __this.el.find("a.active").each(function () {
        var txt = $(this).attr("data-value");
        if (handle.indexOf(txt) == -1) isBoth = 0;
      });
      if (isBoth) {
        var url = "/products/" + handle;
        __this.runClick(handle);
      }
    });
  }
  runClick(handle) {
    var __this = this;

    this.getOptions();
    this.selector.off();

    var el = $('.item[data-handle="' + handle + '"]');

    var selectors = el.find(".selectors");
    $(selectors)
      .find(".selector-wrapper")
      .each(function () {
        $(this).addClass("no-transition");
      });
    var selectorsHTML = selectors.html();

    var title = el.find(".title").text();
    var btn = el.find(".form").html();
    var id = el.attr("data-id");

    //turn off animation

    selectors[0].offsetHeight;

    if (el.find("script").length) el.find("script").appendTo(this.container);

    //unload

    theme.ProductTemplateSection.onSectionUnload(this.section, true);

    this.section.attr("data-product-id", id);
    this.section.data("product-id", id);

    $(".product-area__details__title").text(title);

    this.selectorContainer.html(selectorsHTML);
    this.selectorContainer.find("select").each(function () {
      $(this).clickyBoxes();
    });
    this.btnContainer.html(btn);

    var intURL = "/products/" + handle;
    history.pushState("", "", intURL);

    //reload
    theme.ProductTemplateSection.onSectionLoad(this.section, true);
    theme.initComponents(this.section);
    theme.initShopifyPaymentButtons(this.section);

    for (var x = 0; x < this.activeArr.length; x++) {
      var el = this.selectorContainer.find(
        'a[data-value-lower="' + this.activeArr[x].toLowerCase() + '"]',
      );
      if (el.length) el.trigger("click");
    }

    // re-add animation
    this.selectorContainer.find(".no-transition").each(function () {
      $(this).removeClass("no-transition");
    });

    this.setupStone();
    this.setupGallery(intURL);
    //theme.applyAjaxToProductForm(this.section);
  }

  setupGallery(url) {
    var __this = this;

    $.ajax({ url: url }).done(function (data) {
      var el = $(data).find(".theme-viewport");
      __this.gallery.html(el.html());
      __this.setupImages();
      __this.runImages();
      $(window).trigger("resize");
    });
  }
}

class FormProperties {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.input = this.el.find("input");
    this.name = this.input.attr("name");
    this.header = this.el.find(".option--value");
    this.a = this.el.find("a");
    this.slider = this.el.find(".size-slider");
    this.labelEl = this.el.find(".slider-values");
    this.label = this.labelEl.find("> *");
    this.values = this.labelEl.attr("data-sizes").split(",");
    this.form = '[action="/cart/add"]';

    $(this.form).each(function () {
      __this.input.clone().appendTo($(this));
    });
    this.setupSlider();
    /*
    this.a.on('click', function(){
      if(!$(this).is('.active')) {
        __this.runClick($(this));
      }
    })
    */
  }
  setupSlider() {
    var __this = this;

    var labelLen = this.label.length;

    this.labelEl.width((labelLen * 100) / (labelLen - 1) + "%");
    this.label.width(100 / labelLen + "%");

    this.slider.slider({
      min: 0,
      max: this.values.length - 1,
      step: 1,
      slide: function (e, ui) {},
      stop: function (e, ui) {
        __this.sliderResults(e, ui);
      },
    });
  }
  sliderResults(e, ui) {
    var txt = this.values[ui.value];
    $(this.form + ' [name="' + this.name + '"]').val(txt);
    this.header.text(txt);
  }
  runClick(el) {
    var __this = this;
    el.addClass("active").parent().siblings().find("a").removeClass("active");
    var txt = el.attr("data-value");
    $(this.form + ' [name="' + this.name + '"]').val(txt);
    this.header.text(txt);
  }
}

class FixedColumn {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.parent = this.el.parent();
    $(window).on("scroll", function () {
      __this.setPosition();
    });
  }
  setPosition() {
    var __this = this;
    var top = this.parent.offset().top;
    var bottom = top + this.parent.outerHeight() - this.el.outerHeight();
    var width = this.parent.outerWidth();
    this.el.width(width);
    if (scrollTop < top) {
      this.el.removeClass("fixed").removeClass("fixed--bottom");
    } else if (scrollTop > bottom) {
      this.el.removeClass("fixed").addClass("fixed--bottom");
    } else {
      this.el.addClass("fixed").removeClass("fixed--bottom");
    }
  }
}

class ProductModal {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.btn = this.el.find(".btn");
    this.modalClass = ".product--modal .inner";
    this.modal = $("." + this.el.attr("data-rel"));
    this.isEngraving = this.modal.hasClass("theme-modal--engraving");
    this.modalInput = this.isEngraving
      ? this.modal.find(".engraving-input")
      : this.modal.find("textarea");
    this.input = this.el.find("textarea");
    this.desc = this.el.find(".decription-container");
    this.value = this.el.find(".details-container");
    this.closeClass = '[href="/close"]';
    this.close = this.modal.find(this.closeClass);

    if (this.isEngraving) {
      this.charCurrent = this.modal.find(".engraving-char-current");
      this.charLimit = parseInt(this.modal.attr("data-char-limit")) || 12;
      this.fontSelect = this.modal.find(".engraving-font-select");
      this.fontSelect.on("change", function () {
        __this.applyFontStyle();
      });
    }

    this.toggle = this.el.find(
      this.isEngraving
        ? ".lindelli-engraving-selector__toggle"
        : ".lindelli-order-notes__toggle"
    );

    this.btn.on("click", function (e) {
      e.preventDefault();
      __this.toggle.addClass("toggle--on");
      setTimeout(function () {
        __this.runModal();
      }, 300);
    });

    $("body").on("click", function (e) {
      __this.testClose(e);
    });

    this.modalInput.on("change keyup input", function () {
      __this.runInput();
    });

    this.modal.find('[href="/clear"]').on("click", function (e) {
      e.preventDefault();
      __this.modalInput.val("");
      __this.runInput();
      __this.toggle.removeClass("toggle--on");
      __this.modal.removeClass("active");
    });
  }

  testClose(e) {
    var __this = this;
    if (!this.modal.is(".active")) return;
    e.preventDefault();
    var el = $(e.target);
    var close = 0;
    if (el.is(this.closeClass) || el.closest(this.closeClass).length) close = 1;
    else if (!this.isBtn(el)) {
      if (!el.closest(this.modalClass).length) close = 1;
    }

    if (close == 1) {
      e.preventDefault();
      this.modal.removeClass("active");
      if (!this.modalInput.val()) {
        this.toggle.removeClass("toggle--on");
      }
    }
  }
  isBtn(el) {
    var isBtn = 0;
    var btn = el.closest(".btn");
    if (btn.length) {
      if (btn.is(this.btn)) isBtn = 1;
    }
    return isBtn;
  }

  runModal() {
    this.modal.addClass("active");
  }
  runInput() {
    var value = this.modalInput.val();
    this.value.text(value);
    this.input.val(value);
    if (value.length) {
      this.value.removeClass("hide");
    } else {
      this.value.addClass("hide");
    }
    if (this.isEngraving && this.charCurrent.length) {
      this.charCurrent.text(value.length);
    }
    if (this.isEngraving) {
      this.applyFontStyle();
    }
  }
  applyFontStyle() {
    if (!this.fontSelect || !this.fontSelect.length) return;
    var font = this.fontSelect.val();
    if (font === "Script") {
      this.value.css({ "font-family": "'Pinyon Script', cursive", "font-style": "normal" });
    } else {
      this.value.css({ "font-family": "'Times New Roman', Times, serif", "font-style": "normal" });
    }
  }
}

class PageContent {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.container = this.el.find(".page-content--container");
    this.img = this.el.find("div.image img");
    $(window).on("resize", function () {
      __this.setMinHeight();
    });
    this.img.on("load", function () {
      __this.setMinHeight();
    });
    this.setMinHeight();
  }
  setMinHeight() {
    var __this = this;
    var height = 0;
    this.img.each(function () {
      var testHeight = $(this).height();
      height = testHeight > height ? testHeight : height;
    });
    this.container.css("min-height", height);
  }
}

class PartialClass {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.part = 'input[id*="installment-payment"]';
    this.full = 'input[id*="full-payment"]';
    this.product = this.el.closest(".product-area");
    this.addToCartBtn = this.product.find(".lindelli-main-add-to-cart");
    this.originalPrice = null;
    el.on("click", function (e) {
      e.preventDefault();
      __this.runClick();
    });
  }
  runClick() {
    var __this = this;

    if (!$(this.part).length) return;

    if (this.el.is(".active")) {
      $(this.full).prop("checked", true).trigger("click");
      this.el.removeClass("active");
      this.product.removeAttr("partial-checked");
      this.addInputs(1);
      this.restorePrice();
    } else {
      $(this.part).prop("checked", true).trigger("click");
      this.el.addClass("active");
      this.product.attr("partial-checked", "checked");
      this.addInputs(0);
      this.showPartialPrice();
    }
  }
  showPartialPrice() {
    var priceArea = this.addToCartBtn.find(".price-area");
    this.originalPrice = priceArea.html();
    var partialPrice = priceArea.data("partial-price");
    priceArea.html("<s>" + this.originalPrice + "</s> " + partialPrice);
    this.addToCartBtn.find(".partial").show();
  }
  restorePrice() {
    if (this.originalPrice !== null) {
      this.addToCartBtn.find(".price-area").html(this.originalPrice);
      this.originalPrice = null;
    }
    this.addToCartBtn.find(".partial").hide();
  }
  addInputs(mode) {
    if (mode) {
      $('input[name="properties[_spp2-deposit]"]').remove();
      $('[name="selling_plan"]').remove();
      return;
    }
    var in1 = $('input[name="properties[_spp2-deposit]"]');
    var in2 = $('[name="selling_plan"]');
    if (in1.length) return;

    var form = $('[id*="product-form-template"]').first();
    $(
      '<input type="hidden" name="properties[_spp2-deposit]" value="1">',
    ).appendTo(form);
    $(
      '<input type="hidden" class="spp2__selling-plan" name="selling_plan" value="5185732829">',
    ).appendTo(form);
  }
}

class AsFeatured {
  constructor(el) {
    var __this = this;
    this.el = el;
    this.block = this.el.find(".featured-block");
    this.container = this.el.find(".featured-container");
    this.pos = 0;
    this.scroll = scrollTop;

    this.calcWidth();
    this.runFeatured();
    $(window).on("resize", function () {
      __this.calcWidth();
    });
  }
  calcWidth() {
    var __this = this;
    this.distance = this.block.first().width();
  }
  runFeatured() {
    var __this = this;
    var scr = Math.abs(this.scroll - scrollTop);
    this.scroll = scrollTop;
    var scr = scr / 5;
    var pos = this.pos + 0.75;
    pos += scr;
    if (pos > this.distance) pos = 0;
    this.pos = pos;
    var final = pos * -1;
    this.container.css("transform", "translateX(" + final + "px)");
    requestAnimationFrame(function () {
      __this.runFeatured();
    });
  }
}

function returnString(el) {}

//this is THE STRING this is ANOTHER STRING right here AND ANOTHER goes THE STRING right here...

function iconChevronDown() {
  return '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22.9 22.8" style="enable-background:new 0 0 22.9 22.8;" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#3A2426;stroke-width:0.25;}</style><polyline class="st0" points="3.3,8 11.4,16.1 19.3,8.2 "/></svg>';
}

var scrollTop = $(window).scrollTop();
var scrollBottom = scrollTop + $(window).height();
var viewPortTop = 0;
var viewPortBottom = 0;
var viewPortRatio = 0.2;

function scrollPosition() {
  var offset = $(window).height() * viewPortRatio;
  scrollTop = $(window).scrollTop();
  scrollBottom = scrollTop + $(window).height();
  viewPortTop = scrollTop + offset;
  viewPortBottom = scrollBottom - offset;
}

var isMobile = 0;

$(function () {
  theme.init();

  function scrollGallery() {
    console.log("scrolling");
    $(".product-thumbnail-slider:not([init])").each(function () {
      var el = $(this);
      $(this).attr("init", "init");

      if (!el.hasClass("swiper-container")) {
        el.addClass("swiper-container");
      }

      el.find(".rimage-outer-wrapper").each(function () {
        $(this).addClass("swiper-slide");
      });

      var slideCount = el.find(".swiper-slide").length;
      if (slideCount === 0) return;

      // Get container width with fallback
      var containerWidth =
        el.width() || el.closest(".product-block").width() || el[0].offsetWidth;
      if (!containerWidth) {
        setTimeout(scrollGallery, 200);
        return;
      }

      // Set slide widths before initialization
      el.find(".swiper-slide").css("width", containerWidth + "px");
      el.find(".swiper-wrapper").css(
        "width",
        containerWidth * slideCount + "px",
      );

      el.swiper = new Swiper(el, {
        mode: "horizontal",
        slidesPerView: 1,
        spaceBetween: 0,
        width: containerWidth,
        autoplay: false,
        loop: slideCount > 1,
        speed: 300,
      });
    });
  }

  // Make scrollGallery globally accessible
  window.scrollGallery = scrollGallery;
  theme.scrollGallery = scrollGallery;

  scrollGallery();
  $(window).on("pager", function () {
    scrollGallery();
  });

  $("body,html").on("load", function () {
    $(this).trigger("retrigger");
    $(window).trigger("retrigger");
  });

  document.documentElement.style.setProperty(
    "--window-base-height",
    $(window).height() + "px",
  );

  $(document).ready(function () {
    /*
    const lenis = new Lenis()
    lenis.on('scroll', (e) => {
    
    })
    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)
    */
    $(".diamond-hover").on("click", function (e) {
      e.preventDefault();
    });
    scrollPosition();
    $(window).on("scroll", function () {
      scrollPosition();
    });
    if ($("body").is('[class*="page-"]')) {
      if ($("meta.padding").length) $("body").addClass("page--marginless");
    }
    $(".collection-column--fixed").each(function () {
      $(this).data("fixed-column", new FixedColumn($(this)));
    });
    $(".landing a").each(function () {
      var el = $(this);
      el.hover(
        function () {
          $(this).closest(".landing").addClass("landing--hover");
        },
        function () {
          $(this)
            .closest(".landing")
            .removeClass("landing--hover")
            .removeClass("landing--mousedown");
        },
      );
      el.on("mousedown", function () {
        $(this).closest(".landing").addClass("landing--mousedown");
      });
      el.on("click", function () {
        $(this)
          .closest(".landing")
          .addClass("landing--final")
          .removeClass("landing--mousedown");
      });
    });

    $(".split-column--content").each(function () {
      $.data(
        $(this),
        "sticky",
        new StickyElement(
          $(this),
          ".split-column--products",
          ".split-column--products__inner",
          "bottom",
        ),
      );
    });

    $(".product-float").each(function () {
      $.data($(this), "productFloat", new ProductFloat($(this)));
    });

    $(
      ".section-text-overlay .h2--super p, .text-column--heading h2 p, .split-scroll-banner .split-column--content .tagline p",
    ).each(function () {
      $.data($(this), "string", new ReturnString($(this)));
      $(this)
        .find("span, strong")
        .lettering("words")
        .find('[class*="word"]')
        .lettering();
      $(this)
        .find('[class*="char"]')
        .each(function (index) {
          $(this).addClass("char-index--" + index);
        });
    });

    $(".section-stack")
      .first()
      .each(function () {
        $.data($(this), "stack", new SectionStack());
      });
    $(".split-scroll-banner, .section-featured-collection-scroll").each(
      function () {
        $.data($(this), "split-scroll", new SplitScroll($(this)));
      },
    );

    setTimeout(function () {
      new Related();
    }, 250);

    function runVisibility() {
      $(".data-visibility").each(function () {
        $.data($(this), "visibility", new ElementVisibility($(this)));
      });
    }
    $(window).on("filterComplete", runVisibility);
    runVisibility();

    new CartDrawer();
    new MobileCheck();

    $(".template-product .uses-modal").each(function () {
      $(this).data("productModal", new ProductModal($(this)));
    });

    $(".template-collection").each(function () {
      $(this).data("collectionImages", new CollectionImages($(this)));
    });

    $(".shape-style").each(function () {
      $.data($(this), "shapeStyle", new ShapeStyle($(this)));
    });
    $(".product-area .theme-gallery").each(function () {
      if (!$(".shape-style").length)
        $.data($(this), "productImages", new ProductImages());
    });
    $('[data-option-name="size"]').each(function () {
      $.data($(this), "formProperties", new FormProperties($(this)));
    });

    $(".muse-products").each(function () {
      $.data($(this), "carousel", new MuseProducts($(this)));
    });

    $(".cc-featured-muse").each(function () {
      $.data($(this), "featured", new MuseFeatured($(this)));
    });

    $(".cc-featured-muse h2, .muse-hr").each(function () {
      $.data($(this), "h2", new MuseH2($(this)));
    });

    $(".cc-muse--block").each(function () {
      $.data($(this), "block", new MuseBlock($(this)));
    });

    $(".article-gallery").each(function () {
      $.data($(this), "gallery", new ArticleGallery($(this)));
    });
    $(".article-banner").each(function () {
      $.data($(this), "banner", new ArticleBanner($(this)));
    });

    $(".carousel-ig").each(function () {
      $.data($(this), "carousel", new CarouselInstagram($(this)));
    });

    $(".bundle-block").each(function () {
      $.data($(this), "bundle", new Bundle($(this)));
    });

    $("[data-stockist]").each(function () {
      $.data($(this), "stockist", new StockistModal($(this)));
    });

    $("img").on("load", function () {
      $(window).trigger("retrigger");
    });

    $(".product-details").each(function () {
      $.data(
        $(this),
        "ProductScroll",
        new ProductScroll($(".product-details"), $(".product-details--inner")),
      );
    });

    $(".product-form").each(function () {
      $.data(
        $(this),
        "ProductScroll",
        new ProductScroll($(".product-form"), $(".product-form--inner")),
      );
    });

    $(".cc-product-filter-box").each(function () {
      $.data(
        $(this),
        "boxScroll",
        new BoxScroll(
          ".cc-product-filter-wrapper",
          ".cc-product-filter-box",
          ".product-list-container",
        ),
      );
      $.data($(this), "filterBtn", new FilterState());
    });
    $(window).on("filterComplete reinitFilter", function () {
      $(".cc-product-filter-box").each(function () {
        $.data(
          $(this),
          "boxScroll",
          new BoxScroll(
            ".cc-product-filter-wrapper",
            ".cc-product-filter-box",
            ".product-list-container",
          ),
        );
      });
    });

    $(".proxy--tag").each(function () {
      $.data($(this), "filter-tag", new ProxyTag($(this)));
    });

    new ScrollClass();
    // new ScrollMenu();

    $(".section--page-content").each(function () {
      var el = $(this);
      $.data(el, "PageContent", new PageContent(el));
    });

    $(".stockists--container").each(function () {
      var el = $(this);

      $.data(el, "stockists", new Stockists(el));
    });

    $(".scroll-banner").each(function () {
      $(this).data("scroll", new ScrollBanner($(this)));
    });
    $(".auto-scroll-banner").each(function () {
      $(this).data("autoscroll", new AutoScrollBanner($(this)));
    });

    if ($(".proxy--swatch").length) new ProxySwatch();
    if ($(".instagram-feed").length) new InstagramFeed();
    $("[data-section-scroll]").each(function () {
      $(this).data("scroll", new SectionScroll($(this)));
    });
    $(".partial-btn").each(function () {
      $(this).data("partial", new PartialClass($(this)));
    });
    $(".section--read-more").each(function () {
      var el = $(this);
      var cont = el.find(".read-more-block");
      var btn = el.find(".btn");
      var text = btn.attr("data-text").split("/");
      var textEl = el.find(".cta-text");
      btn.on("click", function (e) {
        e.preventDefault();
        if (cont.is(".active")) {
          cont.removeClass("active");
          cont.height(cont.attr("data-min"));
          if (text.length > 1) textEl.text(text[0]);
        } else {
          cont.addClass("active");
          cont.height(cont.find("> *").first().height());
          if (text.length > 1) textEl.text(text[1]);
        }
      });
    });
    $(".section--as-featured").each(function () {
      $(this).data("asFeatured", new AsFeatured($(this)));
    });
    $('xxx[data-component="feed"]').each(function () {
      var base = $(this);
      var intArray = [];
      for (x = 0; x < 4; x++) {
        intArray.push($(this).find("> div:nth-child(" + x + ")"));
      }

      var el = $('<div id="allFilter"></div>');
      el.prependTo($(this));

      $.each(intArray, function (index, item) {
        item.appendTo(el);
      });
    });

    // Accordion toggle for cart item details
    $(document).on("click", ".details__accordion-toggle", function () {
      var $content = $(this).siblings(".details__accordion-content");
      if ($content.length) {
        var el = $content[0];
        if (el.style.maxHeight && el.style.maxHeight !== "0px") {
          el.style.maxHeight = "0px";
        } else {
          el.style.maxHeight = el.scrollHeight + "px";
        }
      }
    });
  });
});
